// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-04T18:28:14.431Z
// Property: Waterford Place Apartments & Townhomes (ID: 6767906449167622)
// Collections: 19 amenities, 6 floorplans (live), 36 photos, 79 POIs, 5 reviews, 5 virtual tours, 6 office hours, 17 faqs
// Live collections (fetched at runtime): floorplans, floorplans_full, special_offers, fees

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162465",
  "multihub_property_id": "6767906449167622",
  "property_external_id": "1124405",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/waterford-place-apartments-townhomes-overland-park-ks/khzg6j8/",
  "property_google_business_url": "https://www.google.com/maps/place/Waterford+Place+Apartments+%26+Townhomes/@38.9339756,-94.7156524,890m/data=!3m2!1e3!4b1!4m6!3m5!1s0x87c0ead80c44c37b:0xc974affb3ee038cc!8m2!3d38.9339756!4d-94.7156524!16s%2Fg%2F1tgcyl65?entry=ttu&g_ep=EgoyMDI2MDkxNi4wIKXMDSoASAFQAw%3D%3D",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": "1124405 p1099356",
  "property_status": null,
  "property_slug": "waterford-place-apartments-&-townhomes",
  "property_name": "Waterford Place Apartments & Townhomes",
  "property_website_url": "https://www.waterfordplaceaptskc.com/",
  "property_domain": "https://www.waterfordplaceaptskc.com/",
  "property_address": "11220 W 108th St",
  "property_full_address": "11220 W 108th St, Overland Park, KS 66210",
  "property_address_1": "11220 W 108th St",
  "property_address_2": null,
  "property_address_city": "Overland Park",
  "property_address_state": "KS",
  "property_address_zip_full": null,
  "property_address_zip": "66210",
  "property_address_country": "US",
  "property_address_county": "Johnson County",
  "property_neighborhood_address": "Outlying Johnson County KS",
  "property_address_latitude": "38.9339707",
  "property_address_longitude": "-94.7156636",
  "property_email": "rentcafe.wp@pricekc.com",
  "property_phone": "(913) 675-9879",
  "property_call_tracking_phone": "913-675-9879",
  "property_company_name": "Price Brothers",
  "property_company_url": "https://www.pricebrotherskc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Settle into a greener side of Overland Park.</strong> Waterford Place pairs easy one- and two-bedroom apartments and townhomes with in-home comforts, a parklike setting, nature trail access, and simple connections across Johnson County—explore <a href=\"/floor-plans\">floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
  "property_long_description": "<p>Welcome to Waterford Place Apartments &amp; Townhomes, a peaceful community tucked into one of Overland Park's most established residential neighborhoods. Our one- and two-bedroom apartment homes and townhomes offer spacious layouts, quality finishes, and the kind of everyday comfort that makes coming home feel like a reward.</p><p>Inside every residence at Waterford Place Apartments &amp; Townhomes, you will find an in-home washer and dryer, a fully equipped kitchen, and generous closets. Select homes also include a wood-burning fireplace and a private balcony or patio overlooking our beautifully landscaped grounds.</p><p>Step outside and you will find a shimmering swimming pool with a sundeck, picnic areas with BBQ grills, and a surrounding nature trail that winds through our park-like setting. Rentable carports are available for added convenience, and our 24-hour emergency maintenance team ensures your home stays in top shape.</p><p>Browse our available <a href=\"/floor-plans\">floor plans</a>, explore our <a href=\"/amenities\">amenities</a>, or <a href=\"/contact-us\">reach out to our leasing team</a> to get started today.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b675-7b49-73d0-a80e-c730acd2d890.webp",
  "property_featured_image_media": {
    "alt_text": "Home office space with a desk, chair, laptop, and bookshelf next to a blue sofa.",
    "public_id": "01a0b675-7b49-73d0-a80e-c730acd2d890",
    "storage_key": "property/6767906449167622/01a0b675-7b49-73d0-a80e-c730acd2d890.webp",
    "width": 1920,
    "height": 1280
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "192",
  "property_year_built": "1985",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "94.79166666666666",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "Deposit: $175-275",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Restrictions: Aggressive dog breeds including, but not limited to, Pit Bull, American Staffordshire Terrier, Rottweiler, German Shepherd, Malamute, Doberman Pinscher, Chow, Great Dane, Saint Bernard, Akita, Wolf Hybrid, and any mixed breed that includes the aforementioned, are specifically prohibited and Landlord has discretion to limit other breeds. Inherently dangerous or exotic, feral or wild animals are prohibited.",
  "property_pet_policy_description": "The non-refundable fee is $300 for 1 pet, and $500 for 2 pets.",
  "property_petpolicy_info": "https://www.pricebrotherskc.com/petroyaltyclub/",
  "property_online_leasing_url": "https://waterfordplaceaptskc.securecafeapplicant.com/onlineleasing/content3/access/waterford-place58/floorplans",
  "property_resident_portal_url": "https://waterfordplaceaptskc.securecafe.com/residentservices/waterford-place58/userlogin.aspx",
  "property_apply_now_url": "https://waterfordplaceaptskc.securecafeapplicant.com/onlineleasing/content3/access/waterford-place58/login",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019fc98e-2c7c-7218-b0ed-6263d20231a4.webp",
  "property_primary_logo_media": {
    "alt_text": "Waterford Place Apartments & Townhomes logo",
    "public_id": "019fc98e-2c7c-7218-b0ed-6263d20231a4",
    "storage_key": "property/6767906449167622/019fc98e-2c7c-7218-b0ed-6263d20231a4.webp",
    "width": 938,
    "height": 488
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019fc993-37e6-7754-89cd-e8682e43ac68.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019fc993-37e6-7754-89cd-e8682e43ac68",
    "storage_key": "property/6767906449167622/019fc993-37e6-7754-89cd-e8682e43ac68.webp",
    "width": 938,
    "height": 488
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019fc993-1c2b-74a9-a772-30b2723cd840.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019fc993-1c2b-74a9-a772-30b2723cd840",
    "storage_key": "property/6767906449167622/019fc993-1c2b-74a9-a772-30b2723cd840.webp",
    "width": 938,
    "height": 488
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/01a0d9b7-62d2-753a-a137-bd690ff6733b.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff682-589f-76db-bc7c-d7916fa7e182.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff68a-de80-741a-9687-3e84c8c517e3.webp",
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff682-589f-76db-bc7c-d7916fa7e182.webp",
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#0C2340",
  "property_secondary_color": "#886B25",
  "property_font_color": null,
  "property_color_4": "#EFCA08",
  "property_color_3": "#8C271E",
  "property_color_5": "#307FE2",
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "595 - 1106",
  "property_sqft_min": "595",
  "property_sqft_max": "1106",
  "property_price_range": "1215 - 6204",
  "property_price_min": "1215",
  "property_price_max": "6204",
  "property_available_units": 10,
  "property_facebook_url": "https://www.facebook.com/WaterfordPlaceKC",
  "property_instagram_url": "https://www.instagram.com/waterfordplacekc/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJe8NEDNjqwIcRzDjgPvuvdMk",
  "property_youtube_url": "https://www.youtube.com/user/Pricebrothersmgt",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Waterford Place Apartments & Townhomes",
  "property_home_romance_title": "Experience the Joy of Living in Your Perfect Home",
  "property_home_amenities_blurb": "<p><strong>Everyday comfort, easy extras.</strong> At Waterford Place Apartments &amp; Townhomes, in-home conveniences like laundry, spacious closets, and fully equipped kitchens pair with select details such as plank flooring, espresso cabinetry, fireplaces, vaulted ceilings, and private outdoor space. Beyond your door, enjoy nature trail access, a refreshing pool, sundeck, picnic areas with BBQ grills, rentable carports, on-site management, and 24-hour emergency maintenance.</p>",
  "property_home_floorplans_blurb": "<p><strong>Floor plans with easy everyday function.</strong> Explore one- and two-bedroom apartments and townhomes in Overland Park, with layouts ranging from streamlined one-bath designs to roomier two-bath options. In-home washers and dryers, spacious closets, and fully equipped kitchens keep the essentials covered, while select homes add wood-burning fireplaces, kitchen pantries, plank flooring, updated espresso cabinets, and a private balcony or patio.</p>",
  "property_home_gallery_blurb": "<p><strong>Picture life at Waterford Place.</strong> Preview bright interiors with fireplace focal points, streamlined kitchens, generous closets, and select finishes like plank flooring, espresso cabinets, vaulted ceilings, or balconies. Outside, the gallery captures the relaxed Overland Park setting with a sparkling pool, sundeck seating, picnic areas with grills, mature landscaping, and green views worth seeing up close.</p>",
  "property_home_neighborhood_blurb": "<p>Waterford Place Apartments &amp; Townhomes is located just off College Boulevard and Quivira Road in Overland Park, Kansas, with quick access to I-435 and U.S. 69. Corporate Woods, KU Edwards Campus, and the rest of the Kansas City metro are all within easy reach.</p><p>Nearby destinations include Valleybrooke Park, the Indian Creek Trail, the Nerman Museum of Contemporary Art, and a wide variety of shops, restaurants, and everyday conveniences along the College Boulevard and Quivira Road corridor.</p><p>Discover more restaurants, shopping, parks, and destinations on our <a href=\"/neighborhood\">Neighborhood page</a>.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents highlight what sets Waterford Place apart:</strong> responsive service, prompt maintenance, and a peaceful wooded setting in Overland Park. Reviews often call out the helpful leasing and maintenance team, well-kept grounds, easy highway access, and trail connections along the community’s wooded edge—details that make everyday living feel calm, convenient, and cared for.</p>",
  "property_neighborhood_blurb": "<p>Waterford Place Apartments &amp; Townhomes is located at 11220 W. 108th Street in Overland Park, KS, near College Boulevard and Quivira Road. Corporate Woods is a short commute away, I-435 and US-69 connect you to the rest of the Kansas City metro, and RideKC transit options are available nearby.</p><p>Looking for a place to eat near Waterford Place? Our team recommends Houlihan’s for dinner and Palacio Maya Mexican Restaurant for Mexican food. Start the morning at Paris Baguette, grab a smoothie at Hyper Energy Bar, and treat yourself at Cinnabon.</p><p>For time outdoors, Valleybrooke Park and the Indian Creek Trail are close by. The KU Edwards Campus and the Nerman Museum of Contemporary Art are also within a few minutes’ drive.</p><p>Explore the neighborhood map to see what else is nearby.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>At Waterford Place Apartments &amp; Townhomes, the amenities extend well beyond your front door. Our community is designed to enhance the way you live, whether that means a quiet morning by the pool, an afternoon cookout with friends, or an evening outdoors along the trail.</p><p>Our shimmering swimming pool and sundeck provide a refreshing escape during warm Overland Park months. The surrounding picnic areas with BBQ grills are perfect for casual gatherings, and the nature trail that winds through our property offers a peaceful way to enjoy the outdoors without leaving home. Rentable carports are available to keep your vehicle protected.</p><p>Every residence at Waterford Place Apartments &amp; Townhomes includes an in-home washer and dryer, a fully equipped kitchen with quality appliances, and spacious closets. Select homes feature private balconies or patios and cozy wood-burning fireplaces that add warmth and character during cooler months. Central air conditioning, quality window coverings, and modern fixtures round out the interior experience.</p><p>Our on-site management team and 24-hour emergency maintenance professionals are here to make sure everything at Waterford Place Apartments &amp; Townhomes stays in excellent condition. Flexible rent payment options are also available so managing your monthly routine stays simple.</p><p>Explore the full amenity collection above.</p>",
  "property_applynow_blurb": "<p><strong>Ready to make Waterford Place home?</strong> Start your online application for a one- or two-bedroom apartment or townhome in a greener Overland Park setting, with everyday comforts like in-home laundry, spacious closets, and fully equipped kitchens close to relaxing outdoor spaces.</p>",
  "property_contactus_blurb": "<p><strong>Questions? Need directions?</strong> The Waterford Place leasing team is here to help you learn more about our Overland Park apartments and townhomes, from one- and two-bedroom layouts to the relaxed parklike setting near major roadways. Reach out today—we’re happy to point you in the right direction.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Waterford Place?</strong> Start here for quick answers about the community, leasing, amenities, and everyday living in our Overland Park apartments and townhomes. Want more detail on <a href=\"/floor-plans\">floor plans</a> or features? Our leasing team is happy to help.</p>",
  "property_floorplans_blurb": "<p>Finding the right home starts with the right floor plan. At Waterford Place Apartments &amp; Townhomes in Overland Park, Kansas, we offer a range of one- and two-bedroom layouts designed to give you the space, storage, and style you deserve.</p><p>Our one-bedroom apartment homes are thoughtfully proportioned with open living areas, fully equipped kitchens, and generous closets that make organization easy. For those who need a little more room, our two-bedroom apartments and townhomes deliver additional space without sacrificing comfort or location.</p><p>Every floor plan at Waterford Place Apartments &amp; Townhomes includes an in-home washer and dryer so laundry day stays simple. Select layouts feature wood-burning fireplaces and private balconies or patios, giving you a comfortable outdoor space connected to our park-like grounds.</p><p>Waterford Place Apartments &amp; Townhomes is one of the few communities in Overland Park that offers true townhome-style living alongside traditional apartment floor plans. Whether you are looking for single-level convenience or the added privacy of a multi-level home, you will find options worth exploring here.</p><p>Browse the floor plans above, then <a href=\"/contact-us\">contact our leasing team</a> to check availability and <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
  "property_gallery_blurb": "<p>Take a closer look at Waterford Place Apartments &amp; Townhomes in Overland Park, Kansas. Browse photos of apartment and townhome interiors, community spaces, and outdoor amenities to see the details that define the community.</p><p>Explore fully equipped kitchens, spacious living areas, and comfortable bedroom layouts alongside community amenities including our shimmering pool, picnic areas with BBQ grills, nature trail, and beautifully maintained park-like grounds.</p><p>Ready to experience more beyond the photos? <a href=\"/schedule-a-tour\">Schedule a tour</a> of Waterford Place Apartments &amp; Townhomes and explore the community in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Waterford Place on the map.</strong> Find available one- and two-bedroom apartments, then zoom out to see the greener Overland Park setting near College Boulevard and Quivira Road, with parks, trails, shopping, dining, and major routes close by.</p>",
  "property_pets_blurb": "<p>Waterford Place Apartments &amp; Townhomes welcomes cats and dogs, making it one of the pet-friendly communities in Overland Park, Kansas. Our parklike setting, on-site nature trail, and proximity to Valleybrooke Park and the Indian Creek Trail offer plenty of options for spending time outdoors with your pets.</p><p>For complete details about our pet policy, including breed restrictions, pet fees, and monthly pet rent, please <a href=\"/contact-us\">contact our leasing team</a>. Assistance animals are not considered pets and are not subject to pet fees or restrictions. We are happy to walk you through everything and make your move as smooth as possible for you and your pets.</p>",
  "property_referafriend_blurb": "<p><strong>Share the greener side of Overland Park.</strong><br>Love the parklike setting, nature trail access, shimmering pool with Wi-Fi, and everyday comforts at Waterford Place Apartments &amp; Townhomes? Refer a friend and invite them to find their next one- or two-bedroom home here.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident access, made simple.</strong><br>Log in to pay rent, submit maintenance requests, and manage your Waterford Place account—so the everyday ease of your Overland Park apartment or townhome stays right at your fingertips.</p>",
  "property_reviews_blurb": "<p><strong>Hear what residents are saying.</strong> Reviews for Waterford Place Apartments &amp; Townhomes often highlight the same standouts: responsive service, a peaceful wooded setting, and a team that makes the leasing, move-in, and maintenance experience feel easy.</p><p>As you browse the reviews, you’ll see praise for Sheila, Andrea, Angel, Brandon, and the rest of the staff, along with mentions of prompt maintenance, well-kept grounds, highway convenience, and trail access along the wooded edge of the community. One resident sums it up as “a wonderful place to live” for a more “tranquil living experience.”</p>",
  "property_created_at": "1785792908194",
  "property_scheduletour_blurb": "<p>See Waterford Place Apartments &amp; Townhomes for yourself. Schedule a tour to explore available apartment homes, townhomes, and community spaces in Overland Park, Kansas.</p><p>During your visit, take a closer look at apartment and townhome interiors, <a href=\"/floor-plans\">floor plan</a> options, and community <a href=\"/amenities\">amenities</a> while getting answers to your questions from the leasing team.</p><p>Choose an available tour option and time above to plan your visit.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you — your inquiry has been received.</strong><br>Waterford Place’s leasing team will be in touch soon. In the meantime, picture everyday ease in a greener Overland Park setting, with comfortable one- and two-bedroom layouts, relaxing outdoor spaces, and convenient access to local routes that keep life connected.</p>",
  "property_virtualtours_blurb": null,
  "property_copyright": "2026 All Rights Reserved. Waterford Place Apartments & Townhomes",
  "property_seo_title_home": "Waterford Place | Apartments in Overland Park, KS",
  "property_seo_description_home": "1 & 2 bedroom apartments & townhomes in Overland Park, KS. Pool, BBQ grills, nature trails & in-home washer/dryer. Near College Blvd & KU Edwards Campus.",
  "property_seo_title_floorplans": "1 & 2 Bedroom Floor Plans | Waterford Place KS 66210",
  "property_seo_description_floorplans": "Browse 1 & 2 bedroom floor plans at Waterford Place in Overland Park, KS. Washer/dryer, wood-burning fireplace, spacious closets & balconies/patios available.",
  "property_seo_title_amenities": "Pool, BBQ Grills & Nature Trails | Overland Park KS",
  "property_seo_description_amenities": "Waterford Place offers a swimming pool, BBQ grills, rentable carports, nature trail access & parklike setting in Overland Park, KS. Explore all amenities.",
  "property_seo_title_gallery": "Apartment Photos | Waterford Place Overland Park KS",
  "property_seo_description_gallery": "Browse photos of Waterford Place in Overland Park, KS — pool, modern interiors, wood-burning fireplaces, nature trails & community spaces. See yourself here!",
  "property_seo_title_virtualtours": "Virtual Tours | Waterford Place Apartments & Townhomes Apartments",
  "property_seo_description_virtualtours": "Explore Waterford Place Apartments in Overland Park, KS. Take a virtual tour and envision your new spacious one or two-bedroom home!",
  "property_seo_title_interactivemap": "Interactive Map | Waterford Place Apartments & Townhomes Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Waterford Place Apartments & Townhomes in Overland Park, KS. Explore unique floor plans, amenities, and reservable spaces today!",
  "property_seo_title_neighborhood": "Overland Park KS Neighborhood Guide | Apartments",
  "property_seo_description_neighborhood": "Waterford Place is near College Blvd, Quivira Rd, KU Edwards Campus, Corporate Woods & Indian Creek trail. Easy access to I-435 & U.S. 69 in Overland Park.",
  "property_seo_title_contact": "Contact Waterford Place Apartments | Overland Park KS",
  "property_seo_description_contact": "Have questions about our apartments in Overland Park, KS? Reach the Waterford Place team by phone or online at 11220 W 108th St. We'd love to help you!",
  "property_seo_title_faqs": "FAQs | Apartments in Overland Park, KS",
  "property_seo_description_faqs": "Get insights into Waterford Place Apartments & Townhomes in Overland Park, KS! Find answers to your FAQs and learn about our amenities, floor plans, and more.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Overland Park, KS",
  "property_seo_description_reviews": "Experience the charm of Waterford Place Apartments & Townhomes in Overland Park. From cozy fireplaces to scenic trails, see why residents love calling us home!",
  "property_seo_title_applynow": "Apply Now | Apartments in Overland Park, KS",
  "property_seo_description_applynow": "Discover Waterford Place Apartments & Townhomes in Overland Park, KS! Enjoy breathtaking views, amenities, and flexible leases—your new home awaits!",
  "property_seo_title_residentaccess": "Resident Access | Waterford Place Apartments & Townhomes",
  "property_seo_description_residentaccess": "Login to your Waterford Place portal in Overland Park, KS. Manage rent, request maintenance, and connect with your community—all from your fingertips!",
  "property_seo_title_referafriend": "Refer A Friend | Waterford Place Apartments & Townhomes",
  "property_seo_description_referafriend": "Great friends make great neighbors! Refer a friend to Waterford Place Apartments & Townhomes in Overland Park, KS, and enjoy a vibrant community together!",
  "property_seo_title_scheduletour": "Schedule a Tour | Waterford Place Overland Park KS",
  "property_seo_description_scheduletour": "Ready to see Waterford Place in person? Schedule an in-person or virtual tour of our 1 & 2 bedroom apartments & townhomes in Overland Park, KS today!",
  "property_seo_title_privacy": "Privacy Policy | Waterford Place Apartments & Townhomes",
  "property_seo_description_privacy": "Protecting your peace of mind is our priority at Waterford Place Apartments. Read our privacy policy to learn how we safeguard your personal information.",
  "property_seo_title_accessibility": "Website Accessibility | Waterford Place Apartments & Townhomes",
  "property_seo_description_accessibility": "Discover inclusive living at Waterford Place Apartments & Townhomes in Overland Park, where community and digital access come together!",
  "property_seo_title_sitemap": "Sitemap | Waterford Place Apartments & Townhomes",
  "property_seo_description_sitemap": "Navigate your way to your dream home at Waterford Place Apartments & Townhomes. Check out our sitemap for all the amenities and options in Overland Park, KS!",
  "property_seo_title_thankyou": "Thank You | Waterford Place Apartments & Townhomes",
  "property_seo_description_thankyou": "Thank you for reaching out! A Waterford Place team member will be in touch soon to help you find your perfect Overland Park home. Stay tuned!",
  "property_seo_title_pets": "Pet-Friendly Apartments in Overland Park, KS 66210",
  "property_seo_description_pets": "Waterford Place welcomes cats & dogs in Overland Park, KS. Enjoy pet-friendly living near Indian Creek trail & Valleybrooke Park. Ask about our pet policy!",
  "property_updated_at": "1793808435383",
  "amenities": [
    {
      "id": "ec_ff8d442d8679b496ef07b2e1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "yardi",
      "external_id": "88036679",
      "title": "Shimmering Swimming Pool with Wi-Fi",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b675-aeb3-7288-bc9e-b0f13ddb32c0.webp",
      "amenity_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and trees",
        "public_id": "01a0b675-aeb3-7288-bc9e-b0f13ddb32c0",
        "storage_key": "property/6767906449167622/01a0b675-aeb3-7288-bc9e-b0f13ddb32c0.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "A large outdoor swimming pool surrounded by sun loungers and trees.,An aerial view of the Waterford Place Apartments & Townhomes clubhouse pool.,A pool area with a deck and lounge chairs.,A pool with chairs around it and the Waterford Place Apartments & Townhomes clubhouse in the background.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6616322607df58fa903d588b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "yardi",
      "external_id": "88036681",
      "title": "Picnic Tables with BBQ Grills",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b675-af66-753c-8ec2-12bb9832cf4d.webp",
      "amenity_image_media": {
        "alt_text": "Apartment building exterior with picnic table and grill in grassy courtyard",
        "public_id": "01a0b675-af66-753c-8ec2-12bb9832cf4d",
        "storage_key": "property/6767906449167622/01a0b675-af66-753c-8ec2-12bb9832cf4d.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "A picnic table and BBQ grill under a tree, with an apartment building at Waterford Place Apartments & Townhomes in the background",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_740b1dfc79ca3f1d6532a26a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "yardi",
      "external_id": "88036688",
      "title": "Rentable Carports",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b675-ae9e-72c7-a7fb-1a984cf18d72.webp",
      "amenity_image_media": {
        "alt_text": "Covered parking with cars parked underneath, surrounded by trees and apartment buildings.",
        "public_id": "01a0b675-ae9e-72c7-a7fb-1a984cf18d72",
        "storage_key": "property/6767906449167622/01a0b675-ae9e-72c7-a7fb-1a984cf18d72.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "A parking lot with covered parking at Waterford Place Apartments & Townhomes",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9bd621008b1ea4fd67aa713a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "yardi",
      "external_id": "88036690",
      "title": "Parklike Setting",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b675-aeab-7730-9235-332335ca46fb.webp",
      "amenity_image_media": {
        "alt_text": "Exterior view of apartment buildings with grass and trees.",
        "public_id": "01a0b675-aeab-7730-9235-332335ca46fb",
        "storage_key": "property/6767906449167622/01a0b675-aeab-7730-9235-332335ca46fb.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Exterior view of a residential building at Waterford Place Apartments & Townhomes, featuring a mature shade tree and plenty of green space,Exterior view of a residential building at Waterford Place Apartments & Townhomes, featuring a mature shade tree and plenty of green space",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_612b283e7c4d521d35353a82",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "yardi",
      "external_id": "88036691",
      "title": "Nature Trail Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b675-95d0-720e-886f-ea44ea3a5eda.webp",
      "amenity_image_media": {
        "alt_text": "Wooden bridge over a small creek surrounded by lush green trees and foliage.",
        "public_id": "01a0b675-95d0-720e-886f-ea44ea3a5eda",
        "storage_key": "property/6767906449167622/01a0b675-95d0-720e-886f-ea44ea3a5eda.webp",
        "width": 1200,
        "height": 900
      },
      "amenity_image_alt_text": "A pathway surrounded by green trees.,A wooden bridge leads through a lush green forest.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_488c4a2fa0f024a09726ca88",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "yardi",
      "external_id": "88036684",
      "title": "Easy Access to Shopping & 3 Major Highways",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b675-a002-72ac-ade6-f10526bb61e5.webp",
      "amenity_image_media": {
        "alt_text": "Aerial view of apartment buildings nestled near a highway and surrounded by trees.",
        "public_id": "01a0b675-a002-72ac-ade6-f10526bb61e5",
        "storage_key": "property/6767906449167622/01a0b675-a002-72ac-ade6-f10526bb61e5.webp",
        "width": 1200,
        "height": 900
      },
      "amenity_image_alt_text": "An aerial view of Waterford Place Apartments & Townhomes, located right next to a major highway",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4ac45545b7f55be2fe7c279c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "yardi",
      "external_id": "88036676",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5dfd4e133eb3489b9d61487a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "yardi",
      "external_id": "122755415",
      "title": "Flexible Rent Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9a7bed88ff6b7d899f2a4192",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "yardi",
      "external_id": "122468955",
      "title": "Non-Smoking Community",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3d1880c4d18497faa0a190ca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "yardi",
      "external_id": "88036654",
      "title": "Washer/Dryer In-Unit",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b675-bdf7-71ef-be5c-221cc155a6f3.webp",
      "amenity_image_media": {
        "alt_text": "Kitchenette with stainless steel sink, wooden cabinets, and a washer/dryer stack visible through a doorway.",
        "public_id": "01a0b675-bdf7-71ef-be5c-221cc155a6f3",
        "storage_key": "property/6767906449167622/01a0b675-bdf7-71ef-be5c-221cc155a6f3.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Washer and dryer included in each home at Waterford Place Apartments & Townhomes,Washer and dryer included in each home at Waterford Place Apartments & Townhomes",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_24435899cc252c267fb05e39",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "yardi",
      "external_id": "88036665",
      "title": "Private Balconies and Patios*",
      "amount": "false",
      "description": "*with Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b675-babc-77f8-b368-19851ba89d55.webp",
      "amenity_image_media": {
        "alt_text": "Patio with table and chairs set up for a romantic evening.",
        "public_id": "01a0b675-babc-77f8-b368-19851ba89d55",
        "storage_key": "property/6767906449167622/01a0b675-babc-77f8-b368-19851ba89d55.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "A furnished patio with direct access to inside the home at Waterford Place Apartments & Townhomes,A furnished patio with direct access to inside the home at Waterford Place Apartments & Townhomes",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_38984305a916a8322619d1b2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "yardi",
      "external_id": "88036660",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b675-bc7e-763f-9d38-d729de13c619.webp",
      "amenity_image_media": {
        "alt_text": "Kitchen area with wooden cabinets, stainless steel sink, and black appliances.",
        "public_id": "01a0b675-bc7e-763f-9d38-d729de13c619",
        "storage_key": "property/6767906449167622/01a0b675-bc7e-763f-9d38-d729de13c619.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Dishwasher included in each home at Waterford Place Apartments & Townhomes in Overland Park, KS,Dishwasher included in each home at Waterford Place Apartments & Townhomes in Overland Park, KS",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_09c140c54db227908e72779b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "yardi",
      "external_id": "88036657",
      "title": "Cozy Wood Burning Fireplace*",
      "amount": "false",
      "description": "*in Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b675-d5b7-71ff-afcd-eccf3cd3f81f.webp",
      "amenity_image_media": {
        "alt_text": "Living room with fireplace and adjacent kitchen with bar seating.",
        "public_id": "01a0b675-d5b7-71ff-afcd-eccf3cd3f81f",
        "storage_key": "property/6767906449167622/01a0b675-d5b7-71ff-afcd-eccf3cd3f81f.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Wood-burning fireplace included in select homes at Waterford Place Apartments & Townhomes in Overland Park, KS,Wood-burning fireplace included in select homes at Waterford Place Apartments & Townhomes in Overland Park, KS",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_25c357dc6f1ec0f6dfe75f93",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "yardi",
      "external_id": "88036662",
      "title": "Spacious Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b675-d59e-7357-a7d8-0443f58af8bb.webp",
      "amenity_image_media": {
        "alt_text": "Spacious walk-in closet with organized clothing on racks and shelves.",
        "public_id": "01a0b675-d59e-7357-a7d8-0443f58af8bb",
        "storage_key": "property/6767906449167622/01a0b675-d59e-7357-a7d8-0443f58af8bb.webp",
        "width": 1200,
        "height": 799
      },
      "amenity_image_alt_text": "A large walk-in closet with a shoe rack at Waterford Place Apartments & Townhomes in Overland Park, KS",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bb49fafd82f6bff0d214dd57",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "yardi",
      "external_id": "120688755",
      "title": "Plank Flooring*",
      "amount": "false",
      "description": "in Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1bce2223594d727fe84cf595",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "yardi",
      "external_id": "127921901",
      "title": "Kitchen Pantry*",
      "amount": "false",
      "description": "*in Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b675-c4f8-724f-a92e-78f9b125c33d.webp",
      "amenity_image_media": {
        "alt_text": "Kitchen with dining area and pantry.",
        "public_id": "01a0b675-c4f8-724f-a92e-78f9b125c33d",
        "storage_key": "property/6767906449167622/01a0b675-c4f8-724f-a92e-78f9b125c33d.webp",
        "width": 1200,
        "height": 799
      },
      "amenity_image_alt_text": "A kitchen pantry with a dining room table in the background",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_779d69fa7b89293a133c439a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "yardi",
      "external_id": "88036653",
      "title": "1st Floor Private Entry and Physical Address",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2491ec89fc09988a3810538c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "yardi",
      "external_id": "88036670",
      "title": "Spectacular Views*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6b94cc96ff6508886348747a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "yardi",
      "external_id": "121428920",
      "title": "Updated Cabinets*",
      "amount": "false",
      "description": "In Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b675-c52c-74ea-8a9f-9a69e02cc23c.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and granite countertops.",
        "public_id": "01a0b675-c52c-74ea-8a9f-9a69e02cc23c",
        "storage_key": "property/6767906449167622/01a0b675-c52c-74ea-8a9f-9a69e02cc23c.webp",
        "width": 800,
        "height": 533
      },
      "amenity_image_alt_text": "A kitchen with granite countertops and stainless steel appliances.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_d8fa59d2c65a3f709f24e044",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b675-7b49-73d0-a80e-c730acd2d890.webp",
      "image_media": {
        "alt_text": "Home office space with a desk, chair, laptop, and bookshelf next to a blue sofa.",
        "public_id": "01a0b675-7b49-73d0-a80e-c730acd2d890",
        "storage_key": "property/6767906449167622/01a0b675-7b49-73d0-a80e-c730acd2d890.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Create your ideal home office or relaxation space with this versatile loft area, featuring a comfortable sofa and dedicated workspace.",
      "link": "false",
      "alt_text": "Home office space with a desk, chair, laptop, and bookshelf next to a blue sofa.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Waterford-Place-045_Photo_Townhome_Staged-Loft-Area_Angle-1_2026-06-10_Original-Size.jpg"
    },
    {
      "id": "ec_b600a9c57f27d6b43bfdbb41",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b675-e745-7409-8f1a-32d35bce268d.webp",
      "image_media": {
        "alt_text": "Kitchen and dining area with a pantry full of groceries",
        "public_id": "01a0b675-e745-7409-8f1a-32d35bce268d",
        "storage_key": "property/6767906449167622/01a0b675-e745-7409-8f1a-32d35bce268d.webp",
        "width": 2980,
        "height": 1986
      },
      "title": "Apartment",
      "description": "A spacious kitchen and dining area featuring modern appliances, ample cabinet space, and a walk-in pantry stocked with everyday essentials.",
      "link": "false",
      "alt_text": "Kitchen and dining area with a pantry full of groceries",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Waterford-Place-045_Photo_Townhome_Staged-Kitchen_Pantry_2026-06-10_Original-Size.jpg"
    },
    {
      "id": "ec_68fa7a65abf1c47f3fadc0e0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b675-f1e2-728d-8c0b-2735667437e1.webp",
      "image_media": {
        "alt_text": "A blue couch and a desk with a laptop are in a room.",
        "public_id": "01a0b675-f1e2-728d-8c0b-2735667437e1",
        "storage_key": "property/6767906449167622/01a0b675-f1e2-728d-8c0b-2735667437e1.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Relax in this cozy living space, perfect for unwinding after a long day. Featuring a comfortable blue couch and a functional desk area.",
      "link": "false",
      "alt_text": "A blue couch and a desk with a laptop are in a room.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Waterford-Place-045_Photo_Townhome_Staged-Loft-Area_Angle-2_2026-06-10_Original-Size.jpg"
    },
    {
      "id": "ec_da9d9045cf0e9c6bf88f41a1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b675-e812-7042-ab51-da77492a27e9.webp",
      "image_media": {
        "alt_text": "Kitchen with white appliances and wood cabinets",
        "public_id": "01a0b675-e812-7042-ab51-da77492a27e9",
        "storage_key": "property/6767906449167622/01a0b675-e812-7042-ab51-da77492a27e9.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring white appliances, ample wood cabinetry, and a dishwasher. Perfect for home-cooked meals.",
      "link": "false",
      "alt_text": "Kitchen with white appliances and wood cabinets",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Waterford-Place-045_Photo_Townhome_Staged-Kitchen_2026-06-10_Original-Size.jpg"
    },
    {
      "id": "ec_8006bd401c9304e7f64d406c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b675-e7b6-7469-ba35-d0b7785d3884.webp",
      "image_media": {
        "alt_text": "Spacious living room with a staircase leading to a loft, featuring a sofa, coffee table, and a glimpse of the kitchen and dining area.",
        "public_id": "01a0b675-e7b6-7469-ba35-d0b7785d3884",
        "storage_key": "property/6767906449167622/01a0b675-e7b6-7469-ba35-d0b7785d3884.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Step into this beautifully appointed apartment featuring a bright and airy living space, a modern kitchen, and a lofted area perfect for relaxation or a home office.",
      "link": "false",
      "alt_text": "Spacious living room with a staircase leading to a loft, featuring a sofa, coffee table, and a glimpse of the kitchen and dining area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Waterford-Place-045_Photo_Townhome_Staged-Living-Room_Angle-1_2026-06-10_Original-Size.jpg"
    },
    {
      "id": "ec_f27914db31502e0895f6eaf0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b675-e4b1-7616-b5fc-c6ab4a3b61c5.webp",
      "image_media": {
        "alt_text": "Spacious living room with a vaulted ceiling, ceiling fan, fireplace, and stairs.",
        "public_id": "01a0b675-e4b1-7616-b5fc-c6ab4a3b61c5",
        "storage_key": "property/6767906449167622/01a0b675-e4b1-7616-b5fc-c6ab4a3b61c5.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Step into this inviting living room featuring a vaulted ceiling, cozy fireplace, and elegant decor. Perfect for relaxing or entertaining.",
      "link": "false",
      "alt_text": "Spacious living room with a vaulted ceiling, ceiling fan, fireplace, and stairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Waterford-Place-045_Photo_Townhome_Staged-Living-Room_Angle-2_2026-06-10_Original-Size.jpg"
    },
    {
      "id": "ec_e5896562866ab30ded39df67",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b676-22a0-741c-aaf1-9967aaf6d3cc.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, TV, and dresser.",
        "public_id": "01a0b676-22a0-741c-aaf1-9967aaf6d3cc",
        "storage_key": "property/6767906449167622/01a0b676-22a0-741c-aaf1-9967aaf6d3cc.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed, a large flat-screen TV mounted above a modern dresser, and ample natural light from the window.",
      "link": "false",
      "alt_text": "Bedroom with a king-size bed, TV, and dresser.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Waterford-Place-045_Photo_Staged-Bedroom-2_Angle-1_2026-06-10_Original-Size.jpg"
    },
    {
      "id": "ec_df9452f932583a7f99daa87f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b676-2df7-70c9-9964-6d17c90dc5bf.webp",
      "image_media": {
        "alt_text": "King-size bed with blue and yellow accent pillows, bedside tables with lamps, and sliding glass door leading to patio.",
        "public_id": "01a0b676-2df7-70c9-9964-6d17c90dc5bf",
        "storage_key": "property/6767906449167622/01a0b676-2df7-70c9-9964-6d17c90dc5bf.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a king-size bed, decorative pillows, and a ceiling fan. Sliding glass doors open to a private patio area.",
      "link": "false",
      "alt_text": "King-size bed with blue and yellow accent pillows, bedside tables with lamps, and sliding glass door leading to patio.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Waterford-Place-045_Photo_Staged-Bedroom-1_Angle-1_2026-06-10_Original-Size.jpg"
    },
    {
      "id": "ec_01c5ab1bff4636491741513b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b676-1320-75d0-84d6-41a9c4a4dd44.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-sized bed, nightstands, and abstract art.",
        "public_id": "01a0b676-1320-75d0-84d6-41a9c4a4dd44",
        "storage_key": "property/6767906449167622/01a0b676-1320-75d0-84d6-41a9c4a4dd44.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-sized bed, modern nightstands, and vibrant abstract artwork, creating a stylish and inviting atmosphere.",
      "link": "false",
      "alt_text": "Bedroom with a king-sized bed, nightstands, and abstract art.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Waterford-Place-045_Photo_Staged-Bedroom-1_Angle-2_2026-06-10_Original-Size.jpg"
    },
    {
      "id": "ec_21b4b15f46bbbf36b54a9c1b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b676-115e-75cd-81ed-44a94150f838.webp",
      "image_media": {
        "alt_text": "Bathroom with wooden vanity, sink, toilet, and shower.",
        "public_id": "01a0b676-115e-75cd-81ed-44a94150f838",
        "storage_key": "property/6767906449167622/01a0b676-115e-75cd-81ed-44a94150f838.webp",
        "width": 1248,
        "height": 832
      },
      "title": "Apartment",
      "description": "A clean and functional bathroom featuring a wooden vanity with a sink, a toilet, and a glass-enclosed shower. Perfect for your daily routine.",
      "link": "false",
      "alt_text": "Bathroom with wooden vanity, sink, toilet, and shower.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Waterford-Place-045_Photo_Staged-Bathroom-2_2026-06-10_Original-Size.jpg"
    },
    {
      "id": "ec_0cc01b784c75b9a431547f5d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b676-2aeb-72db-acd6-a17d24fee125.webp",
      "image_media": {
        "alt_text": "A staged bedroom with a king-size bed, navy blue headboard, and walk-in closet.",
        "public_id": "01a0b676-2aeb-72db-acd6-a17d24fee125",
        "storage_key": "property/6767906449167622/01a0b676-2aeb-72db-acd6-a17d24fee125.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed, a walk-in closet, and modern decor. Perfect for relaxation and storage.",
      "link": "false",
      "alt_text": "A staged bedroom with a king-size bed, navy blue headboard, and walk-in closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Waterford-Place-045_Photo_Staged-Bedroom-2_Angle-2_2026-06-10_Original-Size.jpg"
    },
    {
      "id": "ec_bfcff1eeab1d1390b4265c3b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b676-22c4-716c-81eb-c4f3bf60a88e.webp",
      "image_media": {
        "alt_text": "Exterior patio with table and chairs",
        "public_id": "01a0b676-22c4-716c-81eb-c4f3bf60a88e",
        "storage_key": "property/6767906449167622/01a0b676-22c4-716c-81eb-c4f3bf60a88e.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Enjoy your private patio space with outdoor seating. Perfect for morning coffee or evening drinks.",
      "link": "false",
      "alt_text": "Exterior patio with table and chairs",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Waterford-Place-045_Photo_Staged-Patio_Angle-1_2026-06-10_Original-Size.jpg"
    },
    {
      "id": "ec_7bd0521e0f186bf0cff5aea8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b676-60d8-73b4-bafc-015396c6bf38.webp",
      "image_media": {
        "alt_text": "Kitchenette with washer and dryer, sink, and cabinets",
        "public_id": "01a0b676-60d8-73b4-bafc-015396c6bf38",
        "storage_key": "property/6767906449167622/01a0b676-60d8-73b4-bafc-015396c6bf38.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Compact kitchenette featuring a stainless steel sink, wooden cabinets, and a stackable washer and dryer for convenience. The space is bright and includes decorative wall art.",
      "link": "false",
      "alt_text": "Kitchenette with washer and dryer, sink, and cabinets",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Waterford-Place-045_Photo_Apartment_Kitchen_Washer-and-Dryer_2026-06-10_Original-Size.jpg"
    },
    {
      "id": "ec_da6dd782be9407ae714c3740",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b676-6645-74cb-8eaa-e3c353563192.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with a breakfast bar, sofa, coffee table, and modern art.",
        "public_id": "01a0b676-6645-74cb-8eaa-e3c353563192",
        "storage_key": "property/6767906449167622/01a0b676-6645-74cb-8eaa-e3c353563192.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Spacious living and kitchen area featuring a breakfast bar, comfortable seating, and stylish decor.",
      "link": "false",
      "alt_text": "Living room and kitchen area with a breakfast bar, sofa, coffee table, and modern art.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Waterford-Place-045_Photo_Apartment_Staged-Living-Room_2026-06-10_Original-Size.jpg"
    },
    {
      "id": "ec_973209f93a88ec6a291adcf8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b676-51fc-76e9-b2db-2d7fb38d2169.webp",
      "image_media": {
        "alt_text": "Kitchen with wooden cabinets, granite countertops, stainless steel sink, dishwasher, and black refrigerator.",
        "public_id": "01a0b676-51fc-76e9-b2db-2d7fb38d2169",
        "storage_key": "property/6767906449167622/01a0b676-51fc-76e9-b2db-2d7fb38d2169.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring ample wooden cabinetry, granite countertops, a deep stainless steel sink, and a dishwasher, perfect for home cooking.",
      "link": "false",
      "alt_text": "Kitchen with wooden cabinets, granite countertops, stainless steel sink, dishwasher, and black refrigerator.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Waterford-Place-045_Photo_Apartment_Kitchen_Angle-1_2026-06-10_Original-Size.jpg"
    },
    {
      "id": "ec_8e3af82b5d4bf6c04ea5fddf",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b676-4b76-723f-a650-fa5d7c2bf791.webp",
      "image_media": {
        "alt_text": "Living room with a fireplace and TV, open to a kitchen with bar seating.",
        "public_id": "01a0b676-4b76-723f-a650-fa5d7c2bf791",
        "storage_key": "property/6767906449167622/01a0b676-4b76-723f-a650-fa5d7c2bf791.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Enjoy the cozy ambiance of the living room featuring a fireplace and mounted TV, seamlessly flowing into the kitchen with convenient bar seating.",
      "link": "false",
      "alt_text": "Living room with a fireplace and TV, open to a kitchen with bar seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Waterford-Place-045_Photo_Apartment_Staged-Living-Room_Fire-Place_2026-06-10_Original-Size.jpg"
    },
    {
      "id": "ec_942da20b8fa1a20600d0ef5c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b676-5027-702a-98c7-c596991dbd9e.webp",
      "image_media": {
        "alt_text": "Kitchen with black refrigerator and oven, wooden cabinets, and white countertops.",
        "public_id": "01a0b676-5027-702a-98c7-c596991dbd9e",
        "storage_key": "property/6767906449167622/01a0b676-5027-702a-98c7-c596991dbd9e.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring a black refrigerator, oven, and ample wooden cabinetry with modern white countertops. Ideal for meal preparation and everyday living.",
      "link": "false",
      "alt_text": "Kitchen with black refrigerator and oven, wooden cabinets, and white countertops.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Waterford-Place-045_Photo_Apartment_Kitchen_Angle-2_2026-06-10_Original-Size.jpg"
    },
    {
      "id": "ec_829b58071502cbbc210af5b6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b676-6a2d-75a8-bd8a-81fa1b839710.webp",
      "image_media": {
        "alt_text": "Private patio with a wooden table and chairs, perfect for outdoor dining.",
        "public_id": "01a0b676-6a2d-75a8-bd8a-81fa1b839710",
        "storage_key": "property/6767906449167622/01a0b676-6a2d-75a8-bd8a-81fa1b839710.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Enjoy your own private outdoor space with a charming patio, furnished for relaxation and dining.",
      "link": "false",
      "alt_text": "Private patio with a wooden table and chairs, perfect for outdoor dining.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Waterford-Place-045_Photo_Staged-Patio_Angle-2_2026-06-10_Original-Size.jpg"
    },
    {
      "id": "ec_b951ed04dafd26e8d8d07160",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b676-6902-77a8-b639-bfa9e7dbbf0d.webp",
      "image_media": {
        "alt_text": "Bathroom with wood vanity, white sink, toilet, and tub with shower.",
        "public_id": "01a0b676-6902-77a8-b639-bfa9e7dbbf0d",
        "storage_key": "property/6767906449167622/01a0b676-6902-77a8-b639-bfa9e7dbbf0d.webp",
        "width": 2528,
        "height": 1684
      },
      "title": "Apartment",
      "description": "Bright and clean bathroom featuring a spacious vanity with ample storage, a deep soaking tub, and a private toilet area.",
      "link": "false",
      "alt_text": "Bathroom with wood vanity, white sink, toilet, and tub with shower.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Waterford-Place-045_Photo_Staged-Bathroom-1_2026-06-10_Original-Size.jpg"
    },
    {
      "id": "ec_f4e7925752e86c82018d7146",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b676-7256-741f-b672-e27b75d965e1.webp",
      "image_media": {
        "alt_text": "Walk-in closet with organized clothing and shelving.",
        "public_id": "01a0b676-7256-741f-b672-e27b75d965e1",
        "storage_key": "property/6767906449167622/01a0b676-7256-741f-b672-e27b75d965e1.webp",
        "width": 2528,
        "height": 1684
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet with ample shelving and hanging space, perfect for organizing your wardrobe.",
      "link": "false",
      "alt_text": "Walk-in closet with organized clothing and shelving.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Waterford-Place-045_Photo_Staged-Walk-in-Closet_2026-06-10_Original-Size.jpg"
    },
    {
      "id": "ec_9ab44e30141d746f5aa08d24",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b676-966f-719d-93f4-de733cc2440a.webp",
      "image_media": {
        "alt_text": "Exterior of a multifamily property with stone accents and a paved road.",
        "public_id": "01a0b676-966f-719d-93f4-de733cc2440a",
        "storage_key": "property/6767906449167622/01a0b676-966f-719d-93f4-de733cc2440a.webp",
        "width": 1920,
        "height": 1440
      },
      "title": "Community",
      "description": "Charming exterior of a multifamily property, featuring natural stone accents and surrounded by lush greenery.",
      "link": "false",
      "alt_text": "Exterior of a multifamily property with stone accents and a paved road.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Waterford-Place-045_Photo_Leasing-Office-Clubhouse-Exterior_Angle-2_2026-06-10_MLS-Size.jpg"
    },
    {
      "id": "ec_5bb8327d4792a3a9e3ec6e97",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b676-aaff-737e-b105-9ae10a88d067.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with manicured lawns and a sidewalk.",
        "public_id": "01a0b676-aaff-737e-b105-9ae10a88d067",
        "storage_key": "property/6767906449167622/01a0b676-aaff-737e-b105-9ae10a88d067.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Charming apartment buildings with lush green lawns and well-maintained exteriors offer a welcoming atmosphere.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with manicured lawns and a sidewalk.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Waterford-Place-045_Photo_Residential-Building-Exterior_Angle-2_2026-06-10_Original-Size.jpg"
    },
    {
      "id": "ec_2d2fdd71a7ee48056470563c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b676-a7d6-770e-a804-58de3245f617.webp",
      "image_media": {
        "alt_text": "Aerial view of a suburban neighborhood with apartment buildings near a highway.",
        "public_id": "01a0b676-a7d6-770e-a804-58de3245f617",
        "storage_key": "property/6767906449167622/01a0b676-a7d6-770e-a804-58de3245f617.webp",
        "width": 1920,
        "height": 1440
      },
      "title": "Community",
      "description": "An aerial view showcases a suburban neighborhood featuring apartment buildings nestled amongst lush trees, with a multi-lane highway visible to the right.",
      "link": "false",
      "alt_text": "Aerial view of a suburban neighborhood with apartment buildings near a highway.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Waterford-Place-045_Drone-Photo_Neighborhood_Highway-Access_2026-06-10_Original-Size.jpg"
    },
    {
      "id": "ec_b878bafb81a5fb1d99676b61",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b676-9724-743f-b36a-2e662f66c55d.webp",
      "image_media": {
        "alt_text": "Waterford Place Clubhouse and Information Center with surrounding landscaping.",
        "public_id": "01a0b676-9724-743f-b36a-2e662f66c55d",
        "storage_key": "property/6767906449167622/01a0b676-9724-743f-b36a-2e662f66c55d.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Welcome to the Waterford Place Clubhouse and Information Center, offering office hours and resident services.",
      "link": "false",
      "alt_text": "Waterford Place Clubhouse and Information Center with surrounding landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Waterford-Place-045_Photo_Leasing-Office-Clubhouse-Exterior_Angle-1_2026-06-10_Original-Size.jpg"
    },
    {
      "id": "ec_9ede9285d78ccba00963751b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b676-a976-7663-ae88-181e0de901b3.webp",
      "image_media": {
        "alt_text": "Exterior of apartment building with stone accents and a large tree in the foreground.",
        "public_id": "01a0b676-a976-7663-ae88-181e0de901b3",
        "storage_key": "property/6767906449167622/01a0b676-a976-7663-ae88-181e0de901b3.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Charming apartment building exterior featuring a mix of siding and stone, with a well-maintained lawn and mature tree providing curb appeal.",
      "link": "false",
      "alt_text": "Exterior of apartment building with stone accents and a large tree in the foreground.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Waterford-Place-045_Photo_Residential-Building-Exterior_Angle-1_2026-06-10_Original-Size.jpg"
    },
    {
      "id": "ec_b3f05ee326c6209da9858c5b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b676-cc34-752f-95a0-cea73082ba70.webp",
      "image_media": {
        "alt_text": "Aerial view of a multifamily property showing buildings, a pool, and surrounding greenery.",
        "public_id": "01a0b676-cc34-752f-95a0-cea73082ba70",
        "storage_key": "property/6767906449167622/01a0b676-cc34-752f-95a0-cea73082ba70.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "Aerial perspective of a multifamily community, highlighting apartment buildings, a refreshing swimming pool, and lush natural surroundings.",
      "link": "false",
      "alt_text": "Aerial view of a multifamily property showing buildings, a pool, and surrounding greenery.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/01-11220 W 108th St-13.jpg"
    },
    {
      "id": "ec_e6e1524740a83abc037e8243",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b676-ce97-70d3-a11b-aff10145fbe9.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment complex buildings and surrounding green landscape.",
        "public_id": "01a0b676-ce97-70d3-a11b-aff10145fbe9",
        "storage_key": "property/6767906449167622/01a0b676-ce97-70d3-a11b-aff10145fbe9.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "An aerial view showcases the apartment complex buildings nestled within a lush, green environment. The image highlights the property's layout and its integration with the natural surroundings.",
      "link": "false",
      "alt_text": "Aerial view of apartment complex buildings and surrounding green landscape.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/03-11220 W 108th St-15.jpg"
    },
    {
      "id": "ec_4a26bb8159c295a9f8f473b1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b676-ecb0-7423-a41e-ea8eaa34e41f.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings and lush green trees with a pool and surrounding roads.",
        "public_id": "01a0b676-ecb0-7423-a41e-ea8eaa34e41f",
        "storage_key": "property/6767906449167622/01a0b676-ecb0-7423-a41e-ea8eaa34e41f.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "Discover this beautiful community featuring apartment buildings nestled amongst mature trees, complete with a refreshing swimming pool and convenient access to roads.",
      "link": "false",
      "alt_text": "Aerial view of apartment buildings and lush green trees with a pool and surrounding roads.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/04-11220 W 108th St-16(1).jpg"
    },
    {
      "id": "ec_2a559be33ee54766dfde9029",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b676-d208-718b-b3e2-1b439b3b7a13.webp",
      "image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and umbrellas.",
        "public_id": "01a0b676-d208-718b-b3e2-1b439b3b7a13",
        "storage_key": "property/6767906449167622/01a0b676-d208-718b-b3e2-1b439b3b7a13.webp",
        "width": 1920,
        "height": 1440
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by lush greenery and comfortable lounge seating. Perfect for relaxing and soaking up the sun.",
      "link": "false",
      "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and umbrellas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Waterford-Place-045_Drone-Photo_Clubhouse-Pool_2026-06-10_Original-Size.jpg"
    },
    {
      "id": "ec_b0e38e1dc797fded85763f2e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b676-e0e7-77ad-8d8c-02e337a7a29c.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "01a0b676-e0e7-77ad-8d8c-02e337a7a29c",
        "storage_key": "property/6767906449167622/01a0b676-e0e7-77ad-8d8c-02e337a7a29c.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our beautiful outdoor swimming pool, surrounded by comfortable lounge chairs and lush greenery. The perfect place to relax and unwind.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Waterford-Place-045_Photo_Pool_Angle-2_2026-06-10_Original-Size.jpg"
    },
    {
      "id": "ec_2ed11e76d9b6e6c9f4316f12",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b676-f6dc-758d-b739-5287b38865c1.webp",
      "image_media": {
        "alt_text": "Wooden bridge over a path surrounded by lush green trees and foliage.",
        "public_id": "01a0b676-f6dc-758d-b739-5287b38865c1",
        "storage_key": "property/6767906449167622/01a0b676-f6dc-758d-b739-5287b38865c1.webp",
        "width": 1920,
        "height": 1440
      },
      "title": "Community",
      "description": "Enjoy the natural beauty with a charming wooden bridge that leads to walking paths surrounded by mature trees and vibrant greenery.",
      "link": "false",
      "alt_text": "Wooden bridge over a path surrounded by lush green trees and foliage.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Waterford-Place-045_Photo_Nature-Trail_Angle-2_2026-06-10_Original-Size.jpg"
    },
    {
      "id": "ec_6bc2bb7bff07444412c91e23",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b676-f9e6-72c5-a9cb-2b396652ffea.webp",
      "image_media": {
        "alt_text": "Apartment complex swimming pool with lounge chairs and deck.",
        "public_id": "01a0b676-f9e6-72c5-a9cb-2b396652ffea",
        "storage_key": "property/6767906449167622/01a0b676-f9e6-72c5-a9cb-2b396652ffea.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim or relax by the pool at this beautiful apartment community. Featuring lounge chairs and ample seating, it's the perfect spot to unwind.",
      "link": "false",
      "alt_text": "Apartment complex swimming pool with lounge chairs and deck.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Waterford-Place-045_Photo_Pool_Angle-1_2026-06-10_Original-Size.jpg"
    },
    {
      "id": "ec_338f207e3759022116c6e549",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b677-1c9e-73dd-9122-93ccfef8f542.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and buildings in the background.",
        "public_id": "01a0b677-1c9e-73dd-9122-93ccfef8f542",
        "storage_key": "property/6767906449167622/01a0b677-1c9e-73dd-9122-93ccfef8f542.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Relax by the sparkling outdoor swimming pool, complete with comfortable lounge chairs and picnic tables for your enjoyment.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and buildings in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Waterford-Place-045_Photo_Pool_Angle-3_2026-06-10_Original-Size.jpg"
    },
    {
      "id": "ec_3929a325467181b27109294d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b677-10a5-70c2-a681-dfc07cd0750c.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with picnic table and grill in grassy courtyard.",
        "public_id": "01a0b677-10a5-70c2-a681-dfc07cd0750c",
        "storage_key": "property/6767906449167622/01a0b677-10a5-70c2-a681-dfc07cd0750c.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy outdoor gatherings with a picnic table and grill located in the scenic courtyard of our apartment community.",
      "link": "false",
      "alt_text": "Apartment building exterior with picnic table and grill in grassy courtyard.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Waterford-Place-045_Photo_BBQ-Grill-and-Picnic-Table_2026-06-10_Original-Size.jpg"
    },
    {
      "id": "ec_8a93e8ec5a1399d3592b3c1d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b677-3317-73cf-887b-740e346bf457.webp",
      "image_media": {
        "alt_text": "Wooden bridge over a creek in a lush green park.",
        "public_id": "01a0b677-3317-73cf-887b-740e346bf457",
        "storage_key": "property/6767906449167622/01a0b677-3317-73cf-887b-740e346bf457.webp",
        "width": 1920,
        "height": 1440
      },
      "title": "Community",
      "description": "Enjoy the natural beauty of our community with this charming wooden bridge, perfect for a leisurely stroll.",
      "link": "false",
      "alt_text": "Wooden bridge over a creek in a lush green park.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Waterford-Place-045_Photo_Nature-Trail_Angle-1_2026-06-10_Original-Size.jpg"
    },
    {
      "id": "ec_64068cd92596308667f13fa3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b677-4a39-75da-b635-0ae0a46e005e.webp",
      "image_media": {
        "alt_text": "Covered parking spaces with cars parked under them, adjacent to apartment buildings.",
        "public_id": "01a0b677-4a39-75da-b635-0ae0a46e005e",
        "storage_key": "property/6767906449167622/01a0b677-4a39-75da-b635-0ae0a46e005e.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Convenient covered parking spaces are available for residents, offering protection from the elements.",
      "link": "false",
      "alt_text": "Covered parking spaces with cars parked under them, adjacent to apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Waterford-Place-045_Photo_Carports_2026-06-10_Original-Size.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_a129e427-9265-433c-b974-698f5ed86900",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "Zephyr Kitchen and Bourbon Bar",
      "poi_type": "Restaurants",
      "poi_address": "10800 Metcalf Ave First Floor, Overland Park, KS 66210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019fc993-bbfb-75c0-a29d-9df9b759614a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-bbfb-75c0-a29d-9df9b759614a",
        "storage_key": "property/6767906449167622/019fc993-bbfb-75c0-a29d-9df9b759614a.webp",
        "width": 1280,
        "height": 793
      },
      "poi_business_url": "https://www.zephyrbourbonbar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5028123602247494285&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "zephyr-kitchen-and-bourbon-bar",
      "poi_latitude": "38.9306106",
      "poi_longitude": "-94.6696562",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-915-5304",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a1-2a26-752e-9ad7-e944cee967c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-2a26-752e-9ad7-e944cee967c0",
        "storage_key": "property/6767906449167622/019ff6a1-2a26-752e-9ad7-e944cee967c0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJd3UfEsvrwIcRjSq4rsZ7x0U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_282792bc-5a9b-4510-b8a7-587d5d3e15d8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "Panera Bread",
      "poi_type": "Restaurants",
      "poi_address": "11022 Metcalf Ave, Overland Park, KS 66210, USA",
      "poi_short_description": "Counter-serve bakery/cafe chain serving sandwiches, salads & more, known for its bread & free WiFi.",
      "poi_long_description": "Counter-serve bakery/cafe chain serving sandwiches, salads & more, known for its bread & free WiFi.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a4-1a80-7019-a958-0e5cf93b7898.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a4-1a80-7019-a958-0e5cf93b7898",
        "storage_key": "property/6767906449167622/019ff6a4-1a80-7019-a958-0e5cf93b7898.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.panerabread.com/en-us/cafe/locations/ks/overland-park/11022-metcalf-avenue?utm_medium=local&utm_source=google&utm_campaign=dpm-dist&utm_term=202360&utm_content=main",
      "poi_directions_map_url": "https://maps.google.com/?cid=17280530710929378876&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "panera-bread",
      "poi_latitude": "38.928532",
      "poi_longitude": "-94.668761",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-345-8400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a4-aacb-753d-af77-bb77a502e30c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-aacb-753d-af77-bb77a502e30c",
        "storage_key": "property/6767906449167622/019ff6a4-aacb-753d-af77-bb77a502e30c.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJX1ikA0nqwIcRPI4sGyDH0O8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_bedb4fad-e74b-425f-b6bd-6e60f080ce79",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "Outback Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "9501 Quivira Rd, Overland Park, KS 66215, USA",
      "poi_short_description": "Boisterous Australian-themed chain serving steaks, seafood & other hearty steakhouse fare.",
      "poi_long_description": "Boisterous Australian-themed chain serving steaks, seafood & other hearty steakhouse fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b671-aaaa-775b-ba23-eea95b026c16.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b671-aaaa-775b-ba23-eea95b026c16",
        "storage_key": "property/6767906449167622/01a0b671-aaaa-775b-ba23-eea95b026c16.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://locations.outback.com/kansas/overland-park/9501-quivira-drive?utm_source=gmb&utm_medium=local_search&utm_campaign=website_cta&y_source=1_MTU1MDIxNjctNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=13942497219588287689&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "outback-steakhouse",
      "poi_latitude": "38.9552365",
      "poi_longitude": "-94.7229534",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-894-5115",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a1-2a26-752e-9ad7-e944cee967c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-2a26-752e-9ad7-e944cee967c0",
        "storage_key": "property/6767906449167622/019ff6a1-2a26-752e-9ad7-e944cee967c0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ4A_PErrwIcRyWxux1mzfcE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_f54457bb-d8df-4490-a886-b53407106389",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "Cheddar's Scratch Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "11865 W 95th St, Overland Park, KS 66214, USA",
      "poi_short_description": "Family-friendly chain serving American comfort food with a Texas twist, plus cocktails.",
      "poi_long_description": "Family-friendly chain serving American comfort food with a Texas twist, plus cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b671-a4eb-769b-a1e2-3fddd1211438.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b671-a4eb-769b-a1e2-3fddd1211438",
        "storage_key": "property/6767906449167622/01a0b671-a4eb-769b-a1e2-3fddd1211438.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.cheddars.com/locations/ks/overland-park/overland-park/2094?cmpid=br:csk_ag:ie_ch:loc_ca:CSKGMB_sn:gmb_gt:overland-park-ks-2094_pl:locurl_rd:1080",
      "poi_directions_map_url": "https://maps.google.com/?cid=15551104286300398531&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cheddars-scratch-kitchen",
      "poi_latitude": "38.95623",
      "poi_longitude": "-94.72209",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-599-3111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a1-2a26-752e-9ad7-e944cee967c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-2a26-752e-9ad7-e944cee967c0",
        "storage_key": "property/6767906449167622/019ff6a1-2a26-752e-9ad7-e944cee967c0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLeUb7EnrwIcRw2P9gfSe0Nc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_e4e58ac4-48cc-4bfc-9240-458ed3f4e175",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "Houlihan's",
      "poi_type": "Restaurants",
      "poi_address": "11851 W 95th St, Overland Park, KS 66214, USA",
      "poi_short_description": "Casual chain restaurant offering comfort food, wine, and cocktails, plus happy-hour specials.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b671-a58c-7489-b92b-8b9450c320b0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b671-a58c-7489-b92b-8b9450c320b0",
        "storage_key": "property/6767906449167622/01a0b671-a58c-7489-b92b-8b9450c320b0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.houlihans.com/location/overland-park-houlihans/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13367718091016146027&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "houlihans",
      "poi_latitude": "38.9562084",
      "poi_longitude": "-94.718101",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-492-3926",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a1-2a26-752e-9ad7-e944cee967c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-2a26-752e-9ad7-e944cee967c0",
        "storage_key": "property/6767906449167622/019ff6a1-2a26-752e-9ad7-e944cee967c0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJty1AEkjrwIcRa4yUUMesg7k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_59197fac-1513-4b2d-9f6f-1fc06f4abd00",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "Parisi - Overland Park",
      "poi_type": "Restaurants",
      "poi_address": "7261 W 80th St, Overland Park, KS 66204, USA",
      "poi_short_description": "Charming coffee shop (part of a chain) serving espresso drinks, breakfast platters, pastries and lunch fare.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b671-af01-7281-b440-33a44cc94ecc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b671-af01-7281-b440-33a44cc94ecc",
        "storage_key": "property/6767906449167622/01a0b671-af01-7281-b440-33a44cc94ecc.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://parisicoffee.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18158977042949201233&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "parisi---overland-park",
      "poi_latitude": "38.9838237",
      "poi_longitude": "-94.6698692",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 913-677-8686",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a4-aacb-753d-af77-bb77a502e30c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-aacb-753d-af77-bb77a502e30c",
        "storage_key": "property/6767906449167622/019ff6a4-aacb-753d-af77-bb77a502e30c.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJfT0bD3jtwIcRUd11AWmlAfw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_10dec719-7ff6-4599-8dd7-7af9c14a5262",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "Strang Hall",
      "poi_type": "Restaurants",
      "poi_address": "7313 W 80th St, Overland Park, KS 66204, USA",
      "poi_short_description": "Industrial-chic food court with diverse eateries & outdoor tables on a grassy lawn.",
      "poi_long_description": "Industrial-chic food court with diverse eateries & outdoor tables on a grassy lawn.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019fc993-b4a8-704d-87c3-57c135f488dc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-b4a8-704d-87c3-57c135f488dc",
        "storage_key": "property/6767906449167622/019fc993-b4a8-704d-87c3-57c135f488dc.webp",
        "width": 1215,
        "height": 911
      },
      "poi_business_url": "https://www.stranghall.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1763956639910195457&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "strang-hall",
      "poi_latitude": "38.983876",
      "poi_longitude": "-94.6706021",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-701-7041",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a1-2a26-752e-9ad7-e944cee967c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-2a26-752e-9ad7-e944cee967c0",
        "storage_key": "property/6767906449167622/019ff6a1-2a26-752e-9ad7-e944cee967c0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJl2WgU63twIcRAfEJ2TfVehg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_69e5b07a-0dbc-49cb-9152-f5f727065ed1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "The Other Place Overland Park",
      "poi_type": "Restaurants",
      "poi_address": "7324 W 80th St, Overland Park, KS 66204, USA",
      "poi_short_description": "Sports-themed pizzeria chain with TVs, plus a menu of pies, wings, beer & more.",
      "poi_long_description": "Sports-themed pizzeria chain with TVs, plus a menu of pies, wings, beer & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b671-a655-7618-99c8-25cdb42736e0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b671-a655-7618-99c8-25cdb42736e0",
        "storage_key": "property/6767906449167622/01a0b671-a655-7618-99c8-25cdb42736e0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://theotherplace.com/location/overland-park-kansas",
      "poi_directions_map_url": "https://maps.google.com/?cid=5504879631191954700&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-other-place-overland-park",
      "poi_latitude": "38.9841287",
      "poi_longitude": "-94.6710351",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-652-9494",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a1-2a26-752e-9ad7-e944cee967c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-2a26-752e-9ad7-e944cee967c0",
        "storage_key": "property/6767906449167622/019ff6a1-2a26-752e-9ad7-e944cee967c0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJe37VXnHswIcRDNV6xNtCZUw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_664459bb-9572-463d-a476-7395e7ac7398",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "Tiki Taco",
      "poi_type": "Restaurants",
      "poi_address": "7514 W 80th St, Overland Park, KS 66204, USA",
      "poi_short_description": "Chill counter-serve spot dishing up Mexican fare like tacos, burritos, fries and nachos.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b671-ab17-717a-b694-1840433ef946.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b671-ab17-717a-b694-1840433ef946",
        "storage_key": "property/6767906449167622/01a0b671-ab17-717a-b694-1840433ef946.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.tikitaco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10020464459330708225&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tiki-taco",
      "poi_latitude": "38.9842413",
      "poi_longitude": "-94.6732033",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 877-213-2463",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a1-2a26-752e-9ad7-e944cee967c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-2a26-752e-9ad7-e944cee967c0",
        "storage_key": "property/6767906449167622/019ff6a1-2a26-752e-9ad7-e944cee967c0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJAc645JztwIcRAWPVxlXXD4s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "taco_restaurant"
    },
    {
      "id": "custom_7c2db498-bce7-4bb3-9d20-6a4f9e3d38b6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "Viona’s Italian Bistro",
      "poi_type": "Restaurants",
      "poi_address": "7933 Marty St, Overland Park, KS 66204, USA",
      "poi_short_description": "Charming Italian eatery serving up pasta standards and pizza in a cozy, family-owned space.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6bd-c232-7139-ae79-6bf21bb6413a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6bd-c232-7139-ae79-6bf21bb6413a",
        "storage_key": "property/6767906449167622/019ff6bd-c232-7139-ae79-6bf21bb6413a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.vionasitalianbistro.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13219270059415858339&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "vionas-italian-bistro",
      "poi_latitude": "38.9850825",
      "poi_longitude": "-94.6696906",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 913-232-8818",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a1-2a26-752e-9ad7-e944cee967c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-2a26-752e-9ad7-e944cee967c0",
        "storage_key": "property/6767906449167622/019ff6a1-2a26-752e-9ad7-e944cee967c0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJqyf0SgjtwIcRo2xwkRRIdLc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_487486ad-01e6-4060-a02f-058bc2875e43",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "Mi Ranchito",
      "poi_type": "Restaurants",
      "poi_address": "7148 W 80th St, Overland Park, KS 66204, USA",
      "poi_short_description": "Local cantina chain serving classic Mexican dishes & margaritas in a relaxed setting.",
      "poi_long_description": "Local cantina chain serving classic Mexican dishes & margaritas in a relaxed setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b671-a72c-7610-ab63-b84c30cece95.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b671-a72c-7610-ab63-b84c30cece95",
        "storage_key": "property/6767906449167622/01a0b671-a72c-7610-ab63-b84c30cece95.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://miranchitokc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14359866803093361876&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mi-ranchito",
      "poi_latitude": "38.9843428",
      "poi_longitude": "-94.668627",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 913-642-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a1-2a26-752e-9ad7-e944cee967c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-2a26-752e-9ad7-e944cee967c0",
        "storage_key": "property/6767906449167622/019ff6a1-2a26-752e-9ad7-e944cee967c0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJyXBHnHPswIcR1NRNjMZ-SMc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_c2236e18-61b7-483b-bb31-162e338ca733",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "Andy's Frozen Custard",
      "poi_type": "Restaurants",
      "poi_address": "11220 Nall Ave, Overland Park, KS 66211, USA",
      "poi_short_description": "Frozen custard sundaes, concretes & more, plus a choice of toppings (with a drive-thru window).",
      "poi_long_description": "Frozen custard sundaes, concretes & more, plus a choice of toppings (with a drive-thru window).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b671-a9d4-7523-be65-9054e323c3ca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b671-a9d4-7523-be65-9054e323c3ca",
        "storage_key": "property/6767906449167622/01a0b671-a9d4-7523-be65-9054e323c3ca.webp",
        "width": 1123,
        "height": 1280
      },
      "poi_business_url": "https://locations.eatandys.com/ll/US/KS/Overland-Park/11220-Nall-Avenue",
      "poi_directions_map_url": "https://maps.google.com/?cid=14377495730659519510&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "andys-frozen-custard",
      "poi_latitude": "38.9247017",
      "poi_longitude": "-94.6493189",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-735-0959",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a1-2a26-752e-9ad7-e51555f2b45b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-2a26-752e-9ad7-e51555f2b45b",
        "storage_key": "property/6767906449167622/019ff6a1-2a26-752e-9ad7-e51555f2b45b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJyxIAML_rwIcRFuynGTEgh8c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dessert_shop"
    },
    {
      "id": "custom_6bca1873-0090-4a5b-b98a-8a1c885c8315",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "CAVA",
      "poi_type": "Restaurants",
      "poi_address": "11895 W 95th St, Overland Park, KS 66214, USA",
      "poi_short_description": "Mediterranean restaurant for thoughtful food with customizable greens & grains bowls, pitas & salad.",
      "poi_long_description": "Mediterranean restaurant for thoughtful food with customizable greens & grains bowls, pitas & salad.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b671-b399-7038-971e-e84819169a70.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b671-b399-7038-971e-e84819169a70",
        "storage_key": "property/6767906449167622/01a0b671-b399-7038-971e-e84819169a70.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://cava.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6388441930628743060&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cava",
      "poi_latitude": "38.9561981",
      "poi_longitude": "-94.7227465",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-393-9024",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a1-2a26-752e-9ad7-e944cee967c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-2a26-752e-9ad7-e944cee967c0",
        "storage_key": "property/6767906449167622/019ff6a1-2a26-752e-9ad7-e944cee967c0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJySRquj_rwIcRlD9WpxZOqFg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mediterranean_restaurant"
    },
    {
      "id": "custom_9817f6ba-a3c4-4a17-8f8d-d52b9c09516e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "BIBIBOP Asian Grill",
      "poi_type": "Restaurants",
      "poi_address": "11875 W 95th St #22, Overland Park, KS 66214, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b671-b78b-70be-8382-fd85e8da67f4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b671-b78b-70be-8382-fd85e8da67f4",
        "storage_key": "property/6767906449167622/01a0b671-b78b-70be-8382-fd85e8da67f4.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://order.bibibop.com/menu/oak-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9554475213884126309&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bibibop-asian-grill",
      "poi_latitude": "38.9562384",
      "poi_longitude": "-94.7225344",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-286-0295",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a1-2a26-752e-9ad7-e944cee967c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-2a26-752e-9ad7-e944cee967c0",
        "storage_key": "property/6767906449167622/019ff6a1-2a26-752e-9ad7-e944cee967c0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJkVOd_wzrwIcRZXTW0pVQmIQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_restaurant"
    },
    {
      "id": "custom_74dd6ffc-9fe4-45f4-9535-87fcf06fb069",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "The Peanut",
      "poi_type": "Restaurants",
      "poi_address": "7938 Santa Fe Dr, Overland Park, KS 66204, USA",
      "poi_short_description": "Sports bar & grill with classic American pub grub such as BLTs & spicy wings as well as drinks.",
      "poi_long_description": "Sports bar & grill with classic American pub grub such as BLTs & spicy wings as well as drinks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b671-b3a1-7459-bed5-1b0677c91920.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b671-b3a1-7459-bed5-1b0677c91920",
        "storage_key": "property/6767906449167622/01a0b671-b3a1-7459-bed5-1b0677c91920.webp",
        "width": 1280,
        "height": 617
      },
      "poi_business_url": "http://www.peanutmidwest.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16406777019279442385&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-peanut",
      "poi_latitude": "38.9844059",
      "poi_longitude": "-94.6720931",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-499-8565",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a1-2a26-752e-9ad7-e944cee967c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-2a26-752e-9ad7-e944cee967c0",
        "storage_key": "property/6767906449167622/019ff6a1-2a26-752e-9ad7-e944cee967c0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJlSYGa3HswIcR0YExr8WUsOM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_16106637-dfa8-4a1b-b5e4-c04f5f7c43fc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "Hen House Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "11930 College Blvd, Overland Park, KS 66210, USA",
      "poi_short_description": "No-frills chain supermarket featuring clean aisles, plus an in-store bakery and deli.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6bd-cd0c-74af-b506-a33fe31697fe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6bd-cd0c-74af-b506-a33fe31697fe",
        "storage_key": "property/6767906449167622/019ff6bd-cd0c-74af-b506-a33fe31697fe.webp",
        "width": 1280,
        "height": 808
      },
      "poi_business_url": "http://henhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11984663071366073173&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hen-house-market",
      "poi_latitude": "38.9286917",
      "poi_longitude": "-94.7258257",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-469-1800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a1-2a37-7079-bb49-ebe689ac353f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-2a37-7079-bb49-ebe689ac353f",
        "storage_key": "property/6767906449167622/019ff6a1-2a37-7079-bb49-ebe689ac353f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJScjUl9PqwIcRVUuE4ZATUqY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_196a757d-9d52-42c7-84cd-f995b2cf5a39",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "11701 Metcalf Ave, Overland Park, KS 66210, USA",
      "poi_short_description": "Department store chain with clothing, electronics, and home goods, plus groceries, and pharmacy services.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019fc993-e93c-77b8-8b6f-782c1050d57d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-e93c-77b8-8b6f-782c1050d57d",
        "storage_key": "property/6767906449167622/019fc993-e93c-77b8-8b6f-782c1050d57d.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/1599-overland-park-ks/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=9310956249863213418&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "38.91484750000001",
      "poi_longitude": "-94.6638388",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-338-2202",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a1-2a26-752e-9ad7-e51555f2b45b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-2a26-752e-9ad7-e51555f2b45b",
        "storage_key": "property/6767906449167622/019ff6a1-2a26-752e-9ad7-e51555f2b45b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJPwmyQxXqwIcRatFMsGApN4E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_dfe6dbbc-5dc8-49a7-97b7-283e450ae2b5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "12290 College Blvd, Overland Park, KS 66210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019fc994-0cda-76fa-8407-8612d065e483.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-0cda-76fa-8407-8612d065e483",
        "storage_key": "property/6767906449167622/019fc994-0cda-76fa-8407-8612d065e483.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/overland-park-ks-pharmacies/12290-w-college-blvd-overland-park-ks-66210/storeid=8601?WT.mc_id=LS_GOOGLE_RX_8601",
      "poi_directions_map_url": "https://maps.google.com/?cid=12658596464354527949&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "38.92859",
      "poi_longitude": "-94.72835",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-327-1332",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a4-aac5-740e-94f0-58e2e7232def.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-aac5-740e-94f0-58e2e7232def",
        "storage_key": "property/6767906449167622/019ff6a4-aac5-740e-94f0-58e2e7232def.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYQ38pyyVwIcRzQrejGperK8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_2e8a00b2-0ed4-4fae-b0aa-e441fdb6a1b6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "Hy-Vee Grocery Store",
      "poi_type": "Shopping & Retail",
      "poi_address": "8501 W 95th St, Overland Park, KS 66212, USA",
      "poi_short_description": "Supermarket with fresh and organic produce as well as a bakery.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a4-2fb7-7407-a37c-4d6dfa2ac172.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a4-2fb7-7407-a37c-4d6dfa2ac172",
        "storage_key": "property/6767906449167622/019ff6a4-2fb7-7407-a37c-4d6dfa2ac172.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.hy-vee.com/stores/detail.aspx?s=128&utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=11669836886695708453&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hy-vee-grocery-store",
      "poi_latitude": "38.955555",
      "poi_longitude": "-94.683945",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-894-1983",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a1-2a37-7079-bb49-ebe689ac353f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-2a37-7079-bb49-ebe689ac353f",
        "storage_key": "property/6767906449167622/019ff6a1-2a37-7079-bb49-ebe689ac353f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7xEOmOzrwIcRJYc_qtGW86E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_c2f960a0-2aa3-46bd-89ec-041b1f60df91",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "Capstone Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "11844 Quivira Rd, Overland Park, KS 66210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b671-c08f-7621-80b1-1399c967bc3b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b671-c08f-7621-80b1-1399c967bc3b",
        "storage_key": "property/6767906449167622/01a0b671-c08f-7621-80b1-1399c967bc3b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.capstone-rx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3304926522333783525&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "capstone-pharmacy",
      "poi_latitude": "38.9135078",
      "poi_longitude": "-94.7243329",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-346-7405",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a4-aac5-740e-94f0-58e2e7232def.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-aac5-740e-94f0-58e2e7232def",
        "storage_key": "property/6767906449167622/019ff6a4-aac5-740e-94f0-58e2e7232def.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJERv5hMPvwIcR5eV4bCl13S0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_f46e45d8-f686-4b19-99c1-b458bab2c13f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "11501 W 97th St, Overland Park, KS 66214, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019fc994-1d28-76db-8ec2-b0f710966f5a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-1d28-76db-8ec2-b0f710966f5a",
        "storage_key": "property/6767906449167622/019fc994-1d28-76db-8ec2-b0f710966f5a.webp",
        "width": 1280,
        "height": 699
      },
      "poi_business_url": "https://www.target.com/sl/overland-park-west/2043",
      "poi_directions_map_url": "https://maps.google.com/?cid=11588226477518387963&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "38.95072090000001",
      "poi_longitude": "-94.7195414",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-905-0285",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a1-2a26-752e-9ad7-e51555f2b45b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-2a26-752e-9ad7-e51555f2b45b",
        "storage_key": "property/6767906449167622/019ff6a1-2a26-752e-9ad7-e51555f2b45b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ_Vxe5zbrwIcR-3pCkZWm0aA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_4bbe6a19-2076-49de-baf5-78f40f9eb6b3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "Oak Park Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "11149 W 95th St, Overland Park, KS 66214, USA",
      "poi_short_description": "Busy, long-standing indoor shopping destination with 2 levels of popular brands & a food court.",
      "poi_long_description": "Busy, long-standing indoor shopping destination with 2 levels of popular brands & a food court.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019fc98e-37d1-7468-87f6-d94a36804e5a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98e-37d1-7468-87f6-d94a36804e5a",
        "storage_key": "property/6767906449167622/019fc98e-37d1-7468-87f6-d94a36804e5a.webp",
        "width": 851,
        "height": 315
      },
      "poi_business_url": "https://www.shopoakparkmall.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3751688215534709327&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oak-park-mall",
      "poi_latitude": "38.9530939",
      "poi_longitude": "-94.7196254",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-888-4400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a1-2a26-752e-9ad7-e51555f2b45b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-2a26-752e-9ad7-e51555f2b45b",
        "storage_key": "property/6767906449167622/019ff6a1-2a26-752e-9ad7-e51555f2b45b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJzVbG9zXrwIcRTyr3Ao6sEDQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_b8fe6df2-50bf-46d6-946f-02484b36f545",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "11900 Metcalf Ave, Overland Park, KS 66213, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6bd-cad2-7012-88cf-c81aa251ca34.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6bd-cad2-7012-88cf-c81aa251ca34",
        "storage_key": "property/6767906449167622/019ff6bd-cad2-7012-88cf-c81aa251ca34.webp",
        "width": 1280,
        "height": 607
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/overlandpark?utm_source=google&utm_medium=organic&utm_campaign=listings&ref_=US_TRF_ALL_UFG_WFM_FRSOC_1001559",
      "poi_directions_map_url": "https://maps.google.com/?cid=8820485549234904426&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "38.9124505",
      "poi_longitude": "-94.6683379",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-663-2951",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a1-2a37-7079-bb49-ebe689ac353f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-2a37-7079-bb49-ebe689ac353f",
        "storage_key": "property/6767906449167622/019ff6a1-2a37-7079-bb49-ebe689ac353f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJz07vMxTqwIcRat2cxN-oaHo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_303cae49-e0e9-45cc-ad04-abe4197d0355",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "Costco Wholesale",
      "poi_type": "Shopping & Retail",
      "poi_address": "12221 Blue Valley Pkwy, Overland Park, KS 66213, USA",
      "poi_short_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_long_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019fc994-2a14-72a2-8957-80df40e69fc6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-2a14-72a2-8957-80df40e69fc6",
        "storage_key": "property/6767906449167622/019fc994-2a14-72a2-8957-80df40e69fc6.webp",
        "width": 1280,
        "height": 518
      },
      "poi_business_url": "https://www.costco.com/warehouse-locations/overland-park-KS-369.html?utm_term=KW&utm_campaign=Homepage&utm_medium=GMB&utm_source=Google&utm_content=Link",
      "poi_directions_map_url": "https://maps.google.com/?cid=12181420978670501186&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "costco-wholesale",
      "poi_latitude": "38.9065093",
      "poi_longitude": "-94.6707763",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-217-2050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a1-2a26-752e-9ad7-e51555f2b45b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-2a26-752e-9ad7-e51555f2b45b",
        "storage_key": "property/6767906449167622/019ff6a1-2a26-752e-9ad7-e51555f2b45b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJg8cveG7qwIcRQn0lFdcZDak",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "warehouse_store"
    },
    {
      "id": "custom_2d829324-bdae-4f86-9cbd-1c9ab10bb3b0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "7-Eleven",
      "poi_type": "Shopping & Retail",
      "poi_address": "10701 Metcalf Ave, Overland Park, KS 66210, USA",
      "poi_short_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_long_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019fc993-f250-71eb-9247-4f4e86fd0210.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-f250-71eb-9247-4f4e86fd0210",
        "storage_key": "property/6767906449167622/019fc993-f250-71eb-9247-4f4e86fd0210.webp",
        "width": 1280,
        "height": 484
      },
      "poi_business_url": "https://www.7-eleven.com/locations/ks/overland-park/10701-metcalf-ave-35523?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=10070375468407503943&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "7-eleven",
      "poi_latitude": "38.9339056",
      "poi_longitude": "-94.6665637",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-649-4960",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a4-aab4-72de-8c7b-a47a1338f4fb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-aab4-72de-8c7b-a47a1338f4fb",
        "storage_key": "property/6767906449167622/019ff6a4-aab4-72de-8c7b-a47a1338f4fb.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJYTF9iUrqwIcRR7w8JSIpwYs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_b4cc62b0-d812-4f8e-a2f8-7ae65de353c8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "Indian Valley Elementary School",
      "poi_type": "Education",
      "poi_address": "11600 Knox St, Overland Park, KS 66210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b671-b65f-763c-860e-ba7d58cfeaa2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b671-b65f-763c-860e-ba7d58cfeaa2",
        "storage_key": "property/6767906449167622/01a0b671-b65f-763c-860e-ba7d58cfeaa2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.bluevalleyk12.org/ive",
      "poi_directions_map_url": "https://maps.google.com/?cid=1890539887141096203&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "indian-valley-elementary-school",
      "poi_latitude": "38.9193538",
      "poi_longitude": "-94.6991534",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-239-6400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a1-2a3b-732c-a170-9b923823f5f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-2a3b-732c-a170-9b923823f5f1",
        "storage_key": "property/6767906449167622/019ff6a1-2a3b-732c-a170-9b923823f5f1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJVWNs6xztwIcRC4vAxgKMPBo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_80df6ef2-967b-43d2-b48d-bfa5738b1822",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "The Goddard School of Overland Park",
      "poi_type": "Education",
      "poi_address": "11060 Oakmont St, Overland Park, KS 66210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019fc994-47d7-7373-acd4-6b2f80d63479.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-47d7-7373-acd4-6b2f80d63479",
        "storage_key": "property/6767906449167622/019fc994-47d7-7373-acd4-6b2f80d63479.webp",
        "width": 1280,
        "height": 855
      },
      "poi_business_url": "https://www.goddardschool.com/schools/ks/overland-park/overland-park?utm_source=google&utm_medium=business_listings&utm_campaign=school&utm_content=main_button",
      "poi_directions_map_url": "https://maps.google.com/?cid=16130861848119914181&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-goddard-school-of-overland-park",
      "poi_latitude": "38.928519",
      "poi_longitude": "-94.730134",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-451-1066",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a1-2a3b-732c-a170-9b923823f5f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-2a3b-732c-a170-9b923823f5f1",
        "storage_key": "property/6767906449167622/019ff6a1-2a3b-732c-a170-9b923823f5f1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJGTeRgSyVwIcRxa4WymJV3N8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_622fd8b2-21c4-43e4-af69-40ee83d240a7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "Johnson County Community College",
      "poi_type": "Education",
      "poi_address": "12345 College Blvd, Overland Park, KS 66210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019fc98e-5b02-764b-88d4-b185ec441246.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98e-5b02-764b-88d4-b185ec441246",
        "storage_key": "property/6767906449167622/019fc98e-5b02-764b-88d4-b185ec441246.webp",
        "width": 960,
        "height": 540
      },
      "poi_business_url": "https://www.jccc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4939079639992649295&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "johnson-county-community-college",
      "poi_latitude": "38.9237619",
      "poi_longitude": "-94.7303185",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-469-8500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a1-2a3b-732c-a170-9b923823f5f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-2a3b-732c-a170-9b923823f5f1",
        "storage_key": "property/6767906449167622/019ff6a1-2a3b-732c-a170-9b923823f5f1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJEejhg2TrwIcRT0Ygo8Mii0Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_97c95ec1-11a8-4dbc-9ca9-4ec68be52a64",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "Shawnee Mission South High School",
      "poi_type": "Education",
      "poi_address": "5800 W 107th St, Overland Park, KS 66207, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019fc994-3f2e-73b0-a5b1-137c3b15ace8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-3f2e-73b0-a5b1-137c3b15ace8",
        "storage_key": "property/6767906449167622/019fc994-3f2e-73b0-a5b1-137c3b15ace8.webp",
        "width": 1280,
        "height": 742
      },
      "poi_business_url": "https://smsouth.smsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3539070587316418831&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shawnee-mission-south-high-school",
      "poi_latitude": "38.9373596",
      "poi_longitude": "-94.6535918",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-993-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a1-2a3b-732c-a170-9b923823f5f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-2a3b-732c-a170-9b923823f5f1",
        "storage_key": "property/6767906449167622/019ff6a1-2a3b-732c-a170-9b923823f5f1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJpYRoydLrwIcRDzkHyPJNHTE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_b3ece5f7-b529-4380-826c-7be666b517ef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "Saint Thomas Aquinas High School",
      "poi_type": "Education",
      "poi_address": "11411 South Pflumm Rd, Overland Park, KS 66210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a4-383f-76ed-8e2f-026552a52605.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a4-383f-76ed-8e2f-026552a52605",
        "storage_key": "property/6767906449167622/019ff6a4-383f-76ed-8e2f-026552a52605.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.stasaints.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4092999226720322010&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saint-thomas-aquinas-high-school",
      "poi_latitude": "38.9221637",
      "poi_longitude": "-94.740104",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-345-1411",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a1-2a3b-732c-a170-9b923823f5f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-2a3b-732c-a170-9b923823f5f1",
        "storage_key": "property/6767906449167622/019ff6a1-2a3b-732c-a170-9b923823f5f1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJB3eqtiSVwIcR2gGdbhxBzTg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_2e5a9010-f9ef-498f-8b09-c4f857d97015",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "Overland Park KinderCare",
      "poi_type": "Education",
      "poi_address": "11842 W 112th St, Overland Park, KS 66210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019fc994-419d-734b-9c52-e5dd6d5def74.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-419d-734b-9c52-e5dd6d5def74",
        "storage_key": "property/6767906449167622/019fc994-419d-734b-9c52-e5dd6d5def74.webp",
        "width": 1000,
        "height": 750
      },
      "poi_business_url": "https://www.kindercare.com/our-centers/overland-park/ks/301300?utm_campaign=kc-lg&utm_source=yext&utm_medium=pro&utm_keyword=&utm_platform=&utm_matchtype=&utm_adgroupid=&utm_content=gmb&y_source=1_NTA3NzU2LTcxNS1sb2NhdGlvbi53ZWJzaXRl",
      "poi_directions_map_url": "https://maps.google.com/?cid=290055847021901174&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "overland-park-kindercare",
      "poi_latitude": "38.9259695",
      "poi_longitude": "-94.721996",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-451-6066",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a1-2a3b-732c-a170-9b923823f5f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-2a3b-732c-a170-9b923823f5f1",
        "storage_key": "property/6767906449167622/019ff6a1-2a3b-732c-a170-9b923823f5f1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZ9Zoj9HqwIcRdvXDjkF8BgQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_23940ed2-e0ff-42b7-b8eb-9a64bda13c3f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "Oak Park-Carpenter Elementary School",
      "poi_type": "Education",
      "poi_address": "10000 Nieman Rd, Overland Park, KS 66214, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0100a-9f6a-769e-ad16-5664b65daa40.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0100a-9f6a-769e-ad16-5664b65daa40",
        "storage_key": "property/6767906449167622/01a0100a-9f6a-769e-ad16-5664b65daa40.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://oakparkcarpenter.smsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15083199623749570531&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oak-park-carpenter-elementary-school",
      "poi_latitude": "38.9458089",
      "poi_longitude": "-94.7145831",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-993-4100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a1-2a3b-732c-a170-9b923823f5f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-2a3b-732c-a170-9b923823f5f1",
        "storage_key": "property/6767906449167622/019ff6a1-2a3b-732c-a170-9b923823f5f1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ5zGHHzvrwIcR4w_mwSRKUtE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_a2547902-03b0-4e52-8b62-1644db591c71",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "Indian Woods Middle School",
      "poi_type": "Education",
      "poi_address": "9700 Woodson Dr, Overland Park, KS 66207, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019fc994-7321-7309-a65b-dc18efe5da37.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-7321-7309-a65b-dc18efe5da37",
        "storage_key": "property/6767906449167622/019fc994-7321-7309-a65b-dc18efe5da37.webp",
        "width": 1280,
        "height": 782
      },
      "poi_business_url": "https://indianwoods.smsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11708930099391460908&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "indian-woods-middle-school",
      "poi_latitude": "38.9522694",
      "poi_longitude": "-94.6552064",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-993-0600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a1-2a3b-732c-a170-9b923823f5f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-2a3b-732c-a170-9b923823f5f1",
        "storage_key": "property/6767906449167622/019ff6a1-2a3b-732c-a170-9b923823f5f1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ4bUrTdvrwIcRLHYbiuN5fqI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_84b1e999-9a28-4b04-b2c4-fd4207e6c686",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "Special Beginnings Early Learning Center",
      "poi_type": "Education",
      "poi_address": "8205 W 108th Terrace, Overland Park, KS 66210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a4-2bcb-710d-94cb-09143ab08cbf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a4-2bcb-710d-94cb-09143ab08cbf",
        "storage_key": "property/6767906449167622/019ff6a4-2bcb-710d-94cb-09143ab08cbf.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.cadence-education.com/locations/ks/cleveland/888/?utm_source=google&utm_medium=local_listing&utm_campaign=local_seo",
      "poi_directions_map_url": "https://maps.google.com/?cid=723580280617887945&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "special-beginnings-early-learning-center",
      "poi_latitude": "38.9322154",
      "poi_longitude": "-94.6810195",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-800-9801",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a1-2a3b-732c-a170-9b923823f5f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-2a3b-732c-a170-9b923823f5f1",
        "storage_key": "property/6767906449167622/019ff6a1-2a3b-732c-a170-9b923823f5f1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJS-ziVPqwIcRyei0eG6sCgo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_6c693788-9f08-421d-bf6e-f4e67ca00656",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "La Petite Academy on Antioch",
      "poi_type": "Education",
      "poi_address": "11114 Antioch Rd, Overland Park, KS 66210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b671-b9ff-76bf-8aea-88e0387da5cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b671-b9ff-76bf-8aea-88e0387da5cc",
        "storage_key": "property/6767906449167622/01a0b671-b9ff-76bf-8aea-88e0387da5cc.webp",
        "width": 1280,
        "height": 1024
      },
      "poi_business_url": "https://www.lapetite.com/your-local-school/overland-park-ks-7046/?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=7046",
      "poi_directions_map_url": "https://maps.google.com/?cid=16956805816941184008&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-petite-academy-on-antioch",
      "poi_latitude": "38.9269735",
      "poi_longitude": "-94.6874284",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 877-271-6466",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a1-2a3b-732c-a170-9b923823f5f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-2a3b-732c-a170-9b923823f5f1",
        "storage_key": "property/6767906449167622/019ff6a1-2a3b-732c-a170-9b923823f5f1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJkUZ_aPjqwIcRCIQOrAytUus",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_be066c8c-8ebd-42fe-9566-d5e65cd282b6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "Nerman Museum of Contemporary Art",
      "poi_type": "Entertainment",
      "poi_address": "12345 College Blvd, Overland Park, KS 66210, USA",
      "poi_short_description": "Johnson County Community College's modern-art facility including an auditorium, cafe & classrooms.",
      "poi_long_description": "Johnson County Community College's modern-art facility including an auditorium, cafe & classrooms.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019fc994-5969-711f-8dc0-604d87db64d8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-5969-711f-8dc0-604d87db64d8",
        "storage_key": "property/6767906449167622/019fc994-5969-711f-8dc0-604d87db64d8.webp",
        "width": 1080,
        "height": 830
      },
      "poi_business_url": "http://www.nermanmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4973184191241098516&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nerman-museum-of-contemporary-art",
      "poi_latitude": "38.924852",
      "poi_longitude": "-94.726824",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-469-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a1-2a3e-745d-bbab-d131c956076a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-2a3e-745d-bbab-d131c956076a",
        "storage_key": "property/6767906449167622/019ff6a1-2a3e-745d-bbab-d131c956076a.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJgVtOx9LqwIcRFJWDQaxMBEU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_9e4f9d72-d65c-425c-bb8c-253da1398215",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "Museum at Prairiefire",
      "poi_type": "Entertainment",
      "poi_address": "5801 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Bright, uniquely designed museum with changing natural history exhibits on dinosaurs & space.",
      "poi_long_description": "Bright, uniquely designed museum with changing natural history exhibits on dinosaurs & space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019fc98e-a465-771a-a834-a57fb9f5ad6d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98e-a465-771a-a834-a57fb9f5ad6d",
        "storage_key": "property/6767906449167622/019fc98e-a465-771a-a834-a57fb9f5ad6d.webp",
        "width": 1170,
        "height": 797
      },
      "poi_business_url": "https://www.visitthemap.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9011883457387750483&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "museum-at-prairiefire",
      "poi_latitude": "38.8819446",
      "poi_longitude": "-94.6520905",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-333-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a1-2a3e-745d-bbab-d131c956076a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-2a3e-745d-bbab-d131c956076a",
        "storage_key": "property/6767906449167622/019ff6a1-2a3e-745d-bbab-d131c956076a.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJOdDvHPHBwIcRU-TQ6kGkEH0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_7711b70e-cde5-4a58-be6a-94d6b379796c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "AMC Prairiefire 17",
      "poi_type": "Entertainment",
      "poi_address": "5724 W 136th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Comfortable entertainment venue featuring a full menu alongside movie screenings of new releases.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a4-44ad-736a-abaa-cec330dceb58.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a4-44ad-736a-abaa-cec330dceb58",
        "storage_key": "property/6767906449167622/019ff6a4-44ad-736a-abaa-cec330dceb58.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/kansas-city/amc-prairiefire-17?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=3727223515720771879&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-prairiefire-17",
      "poi_latitude": "38.8826984",
      "poi_longitude": "-94.651566",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-553-3075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a4-aab3-7226-92cf-21ecd4f9c567.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-aab3-7226-92cf-21ecd4f9c567",
        "storage_key": "property/6767906449167622/019ff6a4-aab3-7226-92cf-21ecd4f9c567.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7fXu5_DBwIcRJ-kENQrCuTM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_fb316c1d-0d26-40fe-bcc2-5afac2789e2d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "AMC Town Center 20",
      "poi_type": "Entertainment",
      "poi_address": "11701 Nall Ave, Leawood, KS 66211, USA",
      "poi_short_description": "Modern cinema equipped with comfy seats, luxury recliners, and a snack bar.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019fc994-93f7-775d-841a-13570c537af6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-93f7-775d-841a-13570c537af6",
        "storage_key": "property/6767906449167622/019fc994-93f7-775d-841a-13570c537af6.webp",
        "width": 1280,
        "height": 783
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/kansas-city/amc-town-center-20?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=2804340900304979407&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-town-center-20",
      "poi_latitude": "38.915838",
      "poi_longitude": "-94.648325",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 913-498-8696",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a4-aab3-7226-92cf-21ecd4f9c567.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-aab3-7226-92cf-21ecd4f9c567",
        "storage_key": "property/6767906449167622/019ff6a4-aab3-7226-92cf-21ecd4f9c567.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6xgReh_qwIcRzwXH1zAF6yY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_00c44690-9bdc-46f1-ba35-673398d298f5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "Deanna Rose Children's Farmstead",
      "poi_type": "Entertainment",
      "poi_address": "13800 Switzer Rd, Overland Park, KS 66221, USA",
      "poi_short_description": "Spacious farmstead featuring replicas of life on the prairie, an ice cream parlor & wagon rides.",
      "poi_long_description": "Spacious farmstead featuring replicas of life on the prairie, an ice cream parlor & wagon rides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019fc994-6656-7148-8fdd-460f9f404f4b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-6656-7148-8fdd-460f9f404f4b",
        "storage_key": "property/6767906449167622/019fc994-6656-7148-8fdd-460f9f404f4b.webp",
        "width": 640,
        "height": 349
      },
      "poi_business_url": "http://www.opkansas.org/things-to-see-and-do/deanna-rose-childrens-farmstead/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7835830010939554497&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "deanna-rose-childrens-farmstead",
      "poi_latitude": "38.877729",
      "poi_longitude": "-94.703345",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 913-897-2360",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a1-2a31-70dc-aa19-9ba76e7d8c62.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-2a31-70dc-aa19-9ba76e7d8c62",
        "storage_key": "property/6767906449167622/019ff6a1-2a31-70dc-aa19-9ba76e7d8c62.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJt6IUwjvAwIcRwbplAuF1vmw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_38ea43e8-1a20-4fdb-bf70-5d98ef588207",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "Overland Park Arboretum & Botanical Gardens",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8909 W 179th St, Overland Park, KS 66013, USA",
      "poi_short_description": "Gardens, trails & recreation areas plus educational programs & events on environmental issues.",
      "poi_long_description": "Gardens, trails & recreation areas plus educational programs & events on environmental issues.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019fc994-8af1-7239-91db-78d5eb71cfb7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-8af1-7239-91db-78d5eb71cfb7",
        "storage_key": "property/6767906449167622/019fc994-8af1-7239-91db-78d5eb71cfb7.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.opkansas.org/recreation-fun/arboretum-botanical-gardens/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8713039177416778041&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "overland-park-arboretum--botanical-gardens",
      "poi_latitude": "38.8033925",
      "poi_longitude": "-94.6891159",
      "poi_miles_from_property": "10.4",
      "poi_walking_minutes": "3 hours 51 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-685-3604",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a1-2a31-70dc-aa19-9ba76e7d8c62.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-2a31-70dc-aa19-9ba76e7d8c62",
        "storage_key": "property/6767906449167622/019ff6a1-2a31-70dc-aa19-9ba76e7d8c62.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6csjvynHwIcROSH92_fu6ng",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_7a4117ef-7f9e-424e-9000-7931edc304d5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "810 Entertainment - Overland Park",
      "poi_type": "Entertainment",
      "poi_address": "13500 Nall Ave, Overland Park, KS 66224, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b671-babe-7406-917e-5bdb432bc8d4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b671-babe-7406-917e-5bdb432bc8d4",
        "storage_key": "property/6767906449167622/01a0b671-babe-7406-917e-5bdb432bc8d4.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "https://810bowling.com/810-entertainment-overland-park-ks",
      "poi_directions_map_url": "https://maps.google.com/?cid=11623012279752903673&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "810-entertainment---overland-park",
      "poi_latitude": "38.8828352",
      "poi_longitude": "-94.6497927",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-600-7088",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a1-2a31-70dc-aa19-9ba76e7d8c62.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-2a31-70dc-aa19-9ba76e7d8c62",
        "storage_key": "property/6767906449167622/019ff6a1-2a31-70dc-aa19-9ba76e7d8c62.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ298S-n_BwIcR-cusShY8TaE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_5b3b132c-5988-44d1-ad9f-acdc53038565",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "Chicken N Pickle - Overland Park",
      "poi_type": "Restaurants",
      "poi_address": "5901 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Family-friendly venue with pickleball courts and other games, plus a casual restaurant.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019fc994-9c43-74c1-9775-9208b82be39d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-9c43-74c1-9775-9208b82be39d",
        "storage_key": "property/6767906449167622/019fc994-9c43-74c1-9775-9208b82be39d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://chickennpickle.com/location/overland-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3904135511973972812&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chicken-n-pickle---overland-park",
      "poi_latitude": "38.8830518",
      "poi_longitude": "-94.6552102",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-703-5950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a1-2a26-752e-9ad7-e944cee967c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-2a26-752e-9ad7-e944cee967c0",
        "storage_key": "property/6767906449167622/019ff6a1-2a26-752e-9ad7-e944cee967c0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ9D8rijBwIcRTEsyKpBGLjY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_06a252c1-6811-4a43-939d-d0ae8eb094df",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "The Brew Top Pub and Patio",
      "poi_type": "Restaurants",
      "poi_address": "6601 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Sizable, easygoing hangout with a patio offering pub grub, a large beer selection & live music.",
      "poi_long_description": "Sizable, easygoing hangout with a patio offering pub grub, a large beer selection & live music.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b671-bd70-759d-935a-425f9adfcb55.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b671-bd70-759d-935a-425f9adfcb55",
        "storage_key": "property/6767906449167622/01a0b671-bd70-759d-935a-425f9adfcb55.webp",
        "width": 1280,
        "height": 950
      },
      "poi_business_url": "https://www.thebrewtop.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=683704552941770679&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-brew-top-pub-and-patio",
      "poi_latitude": "38.8810941",
      "poi_longitude": "-94.6620258",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-897-5500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a1-2a26-752e-9ad7-e944cee967c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-2a26-752e-9ad7-e944cee967c0",
        "storage_key": "property/6767906449167622/019ff6a1-2a26-752e-9ad7-e944cee967c0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJWcCvoOnBwIcRt1dpIasBfQk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_ae5a5313-fd0c-4096-97fa-cf9eb3212b7b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "Andretti Indoor Karting & Games Overland Park",
      "poi_type": "Entertainment",
      "poi_address": "11610 Nall Ave, Overland Park, KS 66211, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0100a-aa7d-748c-8c3c-550ad8c1dcde.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0100a-aa7d-748c-8c3c-550ad8c1dcde",
        "storage_key": "property/6767906449167622/01a0100a-aa7d-748c-8c3c-550ad8c1dcde.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://andrettikarting.com/overlandpark",
      "poi_directions_map_url": "https://maps.google.com/?cid=12146707873347930037&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "andretti-indoor-karting--games-overland-park",
      "poi_latitude": "38.91818490000001",
      "poi_longitude": "-94.6498735",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-937-4201",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a1-2a31-70dc-aa19-9ba76e7d8c62.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-2a31-70dc-aa19-9ba76e7d8c62",
        "storage_key": "property/6767906449167622/019ff6a1-2a31-70dc-aa19-9ba76e7d8c62.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx1VUXQDrwIcRtQdYbXTGkag",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_a2d45ba6-7731-4aa5-b4d3-57d08b0a4eb7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "Saint Luke's South Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "12300 Metcalf Ave, Overland Park, KS 66213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019fc995-3e4b-77dc-9c80-1ac26e7ef2a4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc995-3e4b-77dc-9c80-1ac26e7ef2a4",
        "storage_key": "property/6767906449167622/019fc995-3e4b-77dc-9c80-1ac26e7ef2a4.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.saintlukeskc.org/locations/saint-lukes-south-hospital?utm_source=local-listing&utm_medium=organic&utm_campaign=website-link",
      "poi_directions_map_url": "https://maps.google.com/?cid=8966224544508452770&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saint-lukes-south-hospital",
      "poi_latitude": "38.9041982",
      "poi_longitude": "-94.6695167",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-317-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a1-2a43-73ad-bc19-1d6e418742d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-2a43-73ad-bc19-1d6e418742d2",
        "storage_key": "property/6767906449167622/019ff6a1-2a43-73ad-bc19-1d6e418742d2.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJkT2aF3LqwIcRop_Q17dtbnw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_b717e74d-fd47-455a-b91c-3ae92f2fb670",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "Children's Mercy Kansas",
      "poi_type": "Health and Wellness",
      "poi_address": "5808 W 110th St, Overland Park, KS 66211, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019fc98f-7714-7770-9ef7-fcbcbb2f50f0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98f-7714-7770-9ef7-fcbcbb2f50f0",
        "storage_key": "property/6767906449167622/019fc98f-7714-7770-9ef7-fcbcbb2f50f0.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.childrensmercy.org/Kansas/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8535209985424805612&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "childrens-mercy-kansas",
      "poi_latitude": "38.9299718",
      "poi_longitude": "-94.6522904",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-696-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a1-2a43-73ad-bc19-1d6e418742d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-2a43-73ad-bc19-1d6e418742d2",
        "storage_key": "property/6767906449167622/019ff6a1-2a43-73ad-bc19-1d6e418742d2.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ03Xo8C7qwIcR7M6coEIoc3Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_e983f19d-a72d-4207-a672-8cb9b50192df",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "College Park Family Care - Overland Park",
      "poi_type": "Health and Wellness",
      "poi_address": "11725 W 112th St, Overland Park, KS 66210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019fc994-b0fd-7643-b817-982fcdd486bc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-b0fd-7643-b817-982fcdd486bc",
        "storage_key": "property/6767906449167622/019fc994-b0fd-7643-b817-982fcdd486bc.webp",
        "width": 1195,
        "height": 672
      },
      "poi_business_url": "https://collegeparkfamilycare.com/locations/overland-park-office/?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=4879172158486047093&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "college-park-family-care---overland-park",
      "poi_latitude": "38.9262364",
      "poi_longitude": "-94.7191634",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-469-5579",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a1-2a31-70dc-aa19-9ba76e7d8c62.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-2a31-70dc-aa19-9ba76e7d8c62",
        "storage_key": "property/6767906449167622/019ff6a1-2a31-70dc-aa19-9ba76e7d8c62.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJU3kHWdDqwIcRdWmJKDpNtkM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "doctor"
    },
    {
      "id": "custom_a6eedbdc-91e0-430a-b7c8-c6bf9e80b4f6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "Walmart Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "11701 Metcalf Ave, Overland Park, KS 66210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019fc994-c6c1-7252-b9a6-c9067f6a42ca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-c6c1-7252-b9a6-c9067f6a42ca",
        "storage_key": "property/6767906449167622/019fc994-c6c1-7252-b9a6-c9067f6a42ca.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.walmart.com/store/1599-overland-park-ks/pharmacy/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=17311665733518440288&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-pharmacy",
      "poi_latitude": "38.9151127",
      "poi_longitude": "-94.6643654",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-338-1849",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a4-aac5-740e-94f0-58e2e7232def.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-aac5-740e-94f0-58e2e7232def",
        "storage_key": "property/6767906449167622/019ff6a4-aac5-740e-94f0-58e2e7232def.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9_0mnYrrwIcRYDerdENkP_A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_59617edb-c38f-4bc1-a74a-50aed8cf39e4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "CVS",
      "poi_type": "Health and Wellness",
      "poi_address": "12290 College Blvd, Overland Park, KS 66210, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b671-c0ef-7019-a462-32adaed29200.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b671-c0ef-7019-a462-32adaed29200",
        "storage_key": "property/6767906449167622/01a0b671-c0ef-7019-a462-32adaed29200.webp",
        "width": 1280,
        "height": 493
      },
      "poi_business_url": "https://www.cvs.com/store-locator/overland-park-ks-pharmacies/12290-w-college-blvd-overland-park-ks-66210/storeid=8601?WT.mc_id=LS_GOOGLE_FS_8601",
      "poi_directions_map_url": "https://maps.google.com/?cid=2998230267302422273&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "38.92859",
      "poi_longitude": "-94.72835",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-327-1332",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a1-2a31-70dc-aa19-9ba76e7d8c62.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-2a31-70dc-aa19-9ba76e7d8c62",
        "storage_key": "property/6767906449167622/019ff6a1-2a31-70dc-aa19-9ba76e7d8c62.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJt4BBpyyVwIcRAadi9Yramyk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_667c1a49-1930-4daa-8054-a739cae0f68d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "Hy-Vee Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "8900 W 135th St, Overland Park, KS 66221, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b671-c538-735b-8fba-6462a576f050.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b671-c538-735b-8fba-6462a576f050",
        "storage_key": "property/6767906449167622/01a0b671-c538-735b-8fba-6462a576f050.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.hy-vee.com/my-pharmacy/pharmacy-finder/overland-park-2-8900-w-135-st-overland-park-ks/1509?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=10592957387033179426&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hy-vee-pharmacy",
      "poi_latitude": "38.8853994",
      "poi_longitude": "-94.6884219",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 913-685-3299",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a4-aac5-740e-94f0-58e2e7232def.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-aac5-740e-94f0-58e2e7232def",
        "storage_key": "property/6767906449167622/019ff6a4-aac5-740e-94f0-58e2e7232def.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ____BC3AwIcRInX2np6-AZM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_e43d2d22-f451-4874-9368-1b9df2d3de48",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "7500 Metcalf Ave Walgreens, Overland Park, KS 66204, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0100a-b108-70ed-bdce-b8d9ecbaabae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0100a-b108-70ed-bdce-b8d9ecbaabae",
        "storage_key": "property/6767906449167622/01a0100a-b108-70ed-bdce-b8d9ecbaabae.webp",
        "width": 1280,
        "height": 767
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-7500+metcalf+ave-overland+park-ks-66204/id=4234",
      "poi_directions_map_url": "https://maps.google.com/?cid=15380720365872010384&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "38.9926082",
      "poi_longitude": "-94.6682884",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-341-1725",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a1-2a31-70dc-aa19-9ba76e7d8c62.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-2a31-70dc-aa19-9ba76e7d8c62",
        "storage_key": "property/6767906449167622/019ff6a1-2a31-70dc-aa19-9ba76e7d8c62.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2WJUj2zswIcRkNRqpa5Lc9U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_68f11c3c-2c31-46c5-93cf-2834b523872c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "Genesis Health Clubs - Overland Park",
      "poi_type": "Health and Wellness",
      "poi_address": "6700 W 110th St, Overland Park, KS 66211, USA",
      "poi_short_description": "Tennis and fitness club featuring weight machines, classes and a spa.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019fc98e-e379-720f-ba7c-cc633953091f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98e-e379-720f-ba7c-cc633953091f",
        "storage_key": "property/6767906449167622/019fc98e-e379-720f-ba7c-cc633953091f.webp",
        "width": 867,
        "height": 488
      },
      "poi_business_url": "https://www.genesishealthclubs.com/locations/overland-park.html?utm_campaign=search&utm_medium=organic&utm_source=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=443534702007543199&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "genesis-health-clubs---overland-park",
      "poi_latitude": "38.9300809",
      "poi_longitude": "-94.6634864",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-491-4116",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a1-2a31-70dc-aa19-9ba76e7d8c62.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-2a31-70dc-aa19-9ba76e7d8c62",
        "storage_key": "property/6767906449167622/019ff6a1-2a31-70dc-aa19-9ba76e7d8c62.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKTw7ZzbqwIcRn-W3JnbAJwY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_791291c6-3421-499a-8446-8783f1f07228",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "Fitness Factory KC",
      "poi_type": "Health and Wellness",
      "poi_address": "10550 103rd St, Overland Park, KS 66214, USA",
      "poi_short_description": "Spacious gym with state-of-the-art equipment (from Atlantis and Prime) and personal training services - 24/7 access offered.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b671-c660-750e-981d-1b3dd9f78b1d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b671-c660-750e-981d-1b3dd9f78b1d",
        "storage_key": "property/6767906449167622/01a0b671-c660-750e-981d-1b3dd9f78b1d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://fitnessfactorykc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2981365763699520940&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fitness-factory-kc",
      "poi_latitude": "38.9425637",
      "poi_longitude": "-94.7024734",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-395-9015",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a1-2a31-70dc-aa19-9ba76e7d8c62.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-2a31-70dc-aa19-9ba76e7d8c62",
        "storage_key": "property/6767906449167622/019ff6a1-2a31-70dc-aa19-9ba76e7d8c62.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV0c5P_jrwIcRrDXSul3wXyk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_dcca4c93-a4d7-4dec-acd8-a00809202c8c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "YogaSix",
      "poi_type": "Health and Wellness",
      "poi_address": "6555 W 119th St, Overland Park, KS 66209, USA",
      "poi_short_description": "Relaxed yoga studio offering a variety of classes including hot and restorative types, plus a shop selling yoga apparel.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019fc994-ca56-74e1-a6f3-89f328d11edd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-ca56-74e1-a6f3-89f328d11edd",
        "storage_key": "property/6767906449167622/019fc994-ca56-74e1-a6f3-89f328d11edd.webp",
        "width": 554,
        "height": 312
      },
      "poi_business_url": "https://www.yogasix.com/overland-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=4666487347789615135&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "yogasix",
      "poi_latitude": "38.9124848",
      "poi_longitude": "-94.6603913",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-660-9230",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a1-2a3b-732c-a170-9b923823f5f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-2a3b-732c-a170-9b923823f5f1",
        "storage_key": "property/6767906449167622/019ff6a1-2a3b-732c-a170-9b923823f5f1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJkS5c-rTrwIcRH9DayYSxwkA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_d30e4e18-ca83-4bfc-9855-aa81690a6ef2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "Valleybrooke Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Overland Park, KS 66210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0100a-b428-70b8-bde5-5947dbfbaa30.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0100a-b428-70b8-bde5-5947dbfbaa30",
        "storage_key": "property/6767906449167622/01a0100a-b428-70b8-bde5-5947dbfbaa30.webp",
        "width": 850,
        "height": 1280
      },
      "poi_business_url": "https://www.opkansas.org/things-to-see-and-do/parks/list-of-city-parks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17213302183367309152&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "valleybrooke-park",
      "poi_latitude": "38.9332727",
      "poi_longitude": "-94.7190227",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 913-895-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a1-2a93-75cc-aecd-9516866b4781.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-2a93-75cc-aecd-9516866b4781",
        "storage_key": "property/6767906449167622/019ff6a1-2a93-75cc-aecd-9516866b4781.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJSV_Jw9fqwIcRYHcQwyLv4e4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_2ffd5bd2-c6da-45b3-84a8-530c2072b61a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "Shannon Valley Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "11100 Grant Dr, Overland Park, KS 66210, USA",
      "poi_short_description": "Clean neighborhood park with a playground, trails and a basketball court.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019fc995-c902-70aa-bf2e-62d2cd62d54c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc995-c902-70aa-bf2e-62d2cd62d54c",
        "storage_key": "property/6767906449167622/019fc995-c902-70aa-bf2e-62d2cd62d54c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.opkansas.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1800484435435538277&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shannon-valley-park",
      "poi_latitude": "38.9253018",
      "poi_longitude": "-94.6969299",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-895-6390",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a1-2a93-75cc-aecd-9516866b4781.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-2a93-75cc-aecd-9516866b4781",
        "storage_key": "property/6767906449167622/019ff6a1-2a93-75cc-aecd-9516866b4781.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJkz1GSuXqwIcRZUfB_Q2b_Bg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_780c17da-f048-406a-8814-c1c47134ce6a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "Cobblestone Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "11640 Nieman Rd, Overland Park, KS 66210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0100a-c56c-7775-8957-0f8d5174b50c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0100a-c56c-7775-8957-0f8d5174b50c",
        "storage_key": "property/6767906449167622/01a0100a-c56c-7775-8957-0f8d5174b50c.webp",
        "width": 1280,
        "height": 774
      },
      "poi_business_url": "https://www.opkansas.org/park/cobblestone-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18155108776863223155&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cobblestone-park",
      "poi_latitude": "38.9182224",
      "poi_longitude": "-94.7169458",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a1-2a93-75cc-aecd-9516866b4781.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-2a93-75cc-aecd-9516866b4781",
        "storage_key": "property/6767906449167622/019ff6a1-2a93-75cc-aecd-9516866b4781.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_7SH8cbqwIcRc02CHz7n8_s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_e176dcd1-a57a-4fad-8f14-df5a5f0ad844",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "Corporate Woods Founders Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9300 Indian Creek Pkwy, Overland Park, KS 66210, USA",
      "poi_short_description": "Recreational park featuring forested trails, a splash fountain & an open field for picnics & events.",
      "poi_long_description": "Recreational park featuring forested trails, a splash fountain & an open field for picnics & events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b671-cb18-746c-acde-2a994cdcc7e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b671-cb18-746c-acde-2a994cdcc7e8",
        "storage_key": "property/6767906449167622/01a0b671-cb18-746c-acde-2a994cdcc7e8.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.opkansas.org/park/corporate-woods-founders-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14583573077730300202&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "corporate-woods-founders-park",
      "poi_latitude": "38.933341",
      "poi_longitude": "-94.6949701",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-895-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a1-2a93-75cc-aecd-9516866b4781.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-2a93-75cc-aecd-9516866b4781",
        "storage_key": "property/6767906449167622/019ff6a1-2a93-75cc-aecd-9516866b4781.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ05niK_3qwIcRKpEQdnJCY8o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_6260e695-140b-4c15-bfac-9c0eadfd8534",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "Tomahawk Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3951 W 119th St, Leawood, KS 66209, USA",
      "poi_short_description": "Clean green space featuring swings, slides and trails, along with a baseball field.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b671-cd78-7448-9cbe-11bf475083b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b671-cd78-7448-9cbe-11bf475083b4",
        "storage_key": "property/6767906449167622/01a0b671-cd78-7448-9cbe-11bf475083b4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.leawood.org/facilities/facility/details/Tomahawk-Park-8",
      "poi_directions_map_url": "https://maps.google.com/?cid=18086110426331874286&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tomahawk-park",
      "poi_latitude": "38.9106595",
      "poi_longitude": "-94.6336445",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-339-6700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a1-2a93-75cc-aecd-9516866b4781.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-2a93-75cc-aecd-9516866b4781",
        "storage_key": "property/6767906449167622/019ff6a1-2a93-75cc-aecd-9516866b4781.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJTd8nBu7pwIcR7gMAwpvF_vo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_f90b753c-f8ae-44a5-9936-7a6083662a7d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "Quivira Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "11901 Quivira Rd, Overland Park, KS 66213, USA",
      "poi_short_description": "Small community park featuring a playground, picnic tables & 2 sand volleyball courts.",
      "poi_long_description": "Small community park featuring a playground, picnic tables & 2 sand volleyball courts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b671-cca0-750d-b3fc-f7f43a6270e9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b671-cca0-750d-b3fc-f7f43a6270e9",
        "storage_key": "property/6767906449167622/01a0b671-cca0-750d-b3fc-f7f43a6270e9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.opkansas.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17176832562132200599&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "quivira-park",
      "poi_latitude": "38.9107813",
      "poi_longitude": "-94.7229342",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-895-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a1-2a93-75cc-aecd-9516866b4781.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-2a93-75cc-aecd-9516866b4781",
        "storage_key": "property/6767906449167622/019ff6a1-2a93-75cc-aecd-9516866b4781.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJmbS_K7TqwIcRl6xAYDVeYO4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_ebe58f6c-da59-4b4e-9257-2a48bcf8ec05",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "Shawnee Mission Park - Visitor Services",
      "poi_type": "Entertainment",
      "poi_address": "7900 Renner Rd Visitor Center, Shawnee, KS 66219, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6bd-d421-75b2-80aa-11312a1e0482.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6bd-d421-75b2-80aa-11312a1e0482",
        "storage_key": "property/6767906449167622/019ff6bd-d421-75b2-80aa-11312a1e0482.webp",
        "width": 1280,
        "height": 635
      },
      "poi_business_url": "https://www.jcprd.com/606/Visitor-Services",
      "poi_directions_map_url": "https://maps.google.com/?cid=15068624074064684319&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shawnee-mission-park---visitor-services",
      "poi_latitude": "38.9857532",
      "poi_longitude": "-94.7820515",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 43 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-438-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a1-2a31-70dc-aa19-9ba76e7d8c62.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-2a31-70dc-aa19-9ba76e7d8c62",
        "storage_key": "property/6767906449167622/019ff6a1-2a31-70dc-aa19-9ba76e7d8c62.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJE0oKYO-TwIcRH2WGJMKBHtE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "visitor_center"
    },
    {
      "id": "custom_ca63a5ea-8465-4c34-9983-52744bb85b45",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "Bluejacket Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "10101 Bond St, Overland Park, KS 66214, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b671-cd1e-742b-890e-202ac0fef0c0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b671-cd1e-742b-890e-202ac0fef0c0",
        "storage_key": "property/6767906449167622/01a0b671-cd1e-742b-890e-202ac0fef0c0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://opkansas.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2831659018989769284&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bluejacket-park",
      "poi_latitude": "38.9461948",
      "poi_longitude": "-94.7166283",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-895-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a1-2a93-75cc-aecd-9516866b4781.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-2a93-75cc-aecd-9516866b4781",
        "storage_key": "property/6767906449167622/019ff6a1-2a93-75cc-aecd-9516866b4781.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ40o3ljrrwIcRRJLq_98STCc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_6c3e07b4-a4aa-46d2-9fd8-d0d52e6a18b0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "Oak Park Mall Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "Overland Park, KS 66214, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16122160475460681538&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oak-park-mall-park--ride",
      "poi_latitude": "38.9552209",
      "poi_longitude": "-94.7216049",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a4-ab0d-762c-af55-f60c7790ebec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-ab0d-762c-af55-f60c7790ebec",
        "storage_key": "property/6767906449167622/019ff6a4-ab0d-762c-af55-f60c7790ebec.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJVwpg4UnrwIcRQj-tl4hrvd8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_480968d6-24e7-40e1-b163-3adc3f6728c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "Mission Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "5251 Johnson Dr, Roeland Park, KS 66205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://ridekc.org/locations/mission_transit_center",
      "poi_directions_map_url": "https://maps.google.com/?cid=14750820283784844061&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mission-transit-center",
      "poi_latitude": "39.0229186",
      "poi_longitude": "-94.6460432",
      "poi_miles_from_property": "9.8",
      "poi_walking_minutes": "3 hours 40 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a4-ab0d-762c-af55-f60c7790ebec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-ab0d-762c-af55-f60c7790ebec",
        "storage_key": "property/6767906449167622/019ff6a4-ab0d-762c-af55-f60c7790ebec.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0RGVf9XtwIcRHVOfGOVwtcw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_lot"
    },
    {
      "id": "custom_fe224989-fef1-4b8f-a25f-4909ef87aa8c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "Strang Line Road Park and Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3436547488501433531&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "strang-line-road-park-and-ride",
      "poi_latitude": "38.9082495",
      "poi_longitude": "-94.774183",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a4-ab1d-74bc-b34a-804d6f8aac60.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-ab1d-74bc-b34a-804d6f8aac60",
        "storage_key": "property/6767906449167622/019ff6a4-ab1d-74bc-b34a-804d6f8aac60.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJI1GA1J6VwIcRu4TjsbsRsS8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_db5735ca-84cf-4f54-94f2-3edb8f46df86",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "University of Kansas Edwards Campus",
      "poi_type": "Education",
      "poi_address": "12600 S Quivira Rd, Overland Park, KS 66213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a4-9e8d-726d-8f21-8746002dd844.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a4-9e8d-726d-8f21-8746002dd844",
        "storage_key": "property/6767906449167622/019ff6a4-9e8d-726d-8f21-8746002dd844.webp",
        "width": 1280,
        "height": 795
      },
      "poi_business_url": "http://edwardscampus.ku.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15421529977661014929&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-kansas-edwards-campus",
      "poi_latitude": "38.900081",
      "poi_longitude": "-94.7254776",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-897-8400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a1-2a3b-732c-a170-9b923823f5f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-2a3b-732c-a170-9b923823f5f1",
        "storage_key": "property/6767906449167622/019ff6a1-2a3b-732c-a170-9b923823f5f1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJcfRKua3qwIcRkcOF085HBNY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_36982efa-5d3e-4989-b12d-ffd31ce599a1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "BikeWalkKC",
      "poi_type": "Transportation & Transit",
      "poi_address": "1106 E 30th St Ste G, Kansas City, MO 64109, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b671-daa1-747f-ba0c-ef1db1324c87.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b671-daa1-747f-ba0c-ef1db1324c87",
        "storage_key": "property/6767906449167622/01a0b671-daa1-747f-ba0c-ef1db1324c87.webp",
        "width": 1280,
        "height": 790
      },
      "poi_business_url": "http://www.bikewalkkc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1500022561484279170&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bikewalkkc",
      "poi_latitude": "39.0723805",
      "poi_longitude": "-94.5706683",
      "poi_miles_from_property": "15.8",
      "poi_walking_minutes": "5 hours 55 mins",
      "poi_biking_minutes": "1 hour 38 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 816-205-7056",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a1-2a31-70dc-aa19-9ba76e7d8c62.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-2a31-70dc-aa19-9ba76e7d8c62",
        "storage_key": "property/6767906449167622/019ff6a1-2a31-70dc-aa19-9ba76e7d8c62.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJR25bmPLxwIcRgo1XfJIm0RQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "non_profit_organization"
    },
    {
      "id": "custom_83c0dca8-5f2d-4fbd-80a7-f739795fe625",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "Kansas City International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1 Kansas City Blvd, Kansas City, MO 64153, USA",
      "poi_short_description": "Airport featuring domestic & global flights plus free WiFi & a variety of eateries.",
      "poi_long_description": "Airport featuring domestic & global flights plus free WiFi & a variety of eateries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019fc995-3483-741f-b008-b844fec63733.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc995-3483-741f-b008-b844fec63733",
        "storage_key": "property/6767906449167622/019fc995-3483-741f-b008-b844fec63733.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.flykc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14109162014977743520&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kansas-city-international-airport",
      "poi_latitude": "39.3013901",
      "poi_longitude": "-94.7104232",
      "poi_miles_from_property": "37.9",
      "poi_walking_minutes": "14 hours 6 mins",
      "poi_biking_minutes": "4 hours 9 mins",
      "poi_driving_minutes": "35 mins",
      "poi_business_phone": "+1 816-243-5237",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a1-2eb3-708b-acae-5f404c241b70.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-2eb3-708b-acae-5f404c241b70",
        "storage_key": "property/6767906449167622/019ff6a1-2eb3-708b-acae-5f404c241b70.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJmYfmiAhewIcRoNouXRnQzcM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_f50396e2-2f42-498c-a67d-7ac697a90c3a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "Kansas City",
      "poi_type": "Transportation & Transit",
      "poi_address": "30 W Pershing Rd Union Station, Kansas City, MO 64108, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019fc995-c0b1-70a7-be4d-f62ceac69ff3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc995-c0b1-70a7-be4d-f62ceac69ff3",
        "storage_key": "property/6767906449167622/019fc995-c0b1-70a7-be4d-f62ceac69ff3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=KCY",
      "poi_directions_map_url": "https://maps.google.com/?cid=3787247529242741214&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kansas-city",
      "poi_latitude": "39.0847966",
      "poi_longitude": "-94.5853578",
      "poi_miles_from_property": "16",
      "poi_walking_minutes": "5 hours 54 mins",
      "poi_biking_minutes": "1 hour 37 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a4-ab24-76fd-beca-698c5194cd00.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-ab24-76fd-beca-698c5194cd00",
        "storage_key": "property/6767906449167622/019ff6a4-ab24-76fd-beca-698c5194cd00.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJxbu2nD_wwIcR3kn96I8BjzQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_5787a500-6dd0-47c9-85e6-e6237a147e94",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "75th and Metcalf Shopping Center via 635",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7527 Metcalf Ave, Overland Park, KS 66204, USA",
      "poi_short_description": "Business center offering a pharmacy and a variety of stores.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b671-d424-71fd-99ba-d33579c6e35a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b671-d424-71fd-99ba-d33579c6e35a",
        "storage_key": "property/6767906449167622/01a0b671-d424-71fd-99ba-d33579c6e35a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.lane4group.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2506208036110720070&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "75th-and-metcalf-shopping-center-via-635",
      "poi_latitude": "38.9924392",
      "poi_longitude": "-94.666748",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-643-6330",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a1-2a31-70dc-aa19-9ba76e7d8c62.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-2a31-70dc-aa19-9ba76e7d8c62",
        "storage_key": "property/6767906449167622/019ff6a1-2a31-70dc-aa19-9ba76e7d8c62.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo2vXvWzswIcRRtybLe7WxyI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "business_center"
    },
    {
      "id": "custom_09f5b265-0f84-45d6-bd0d-6fd82ce405e7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "Black & Veatch",
      "poi_type": "Major Employers & Offices",
      "poi_address": "11401 Lamar Ave, Overland Park, KS 66211, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019fc995-55a9-72dd-8b8c-65c7640b89d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc995-55a9-72dd-8b8c-65c7640b89d6",
        "storage_key": "property/6767906449167622/019fc995-55a9-72dd-8b8c-65c7640b89d6.webp",
        "width": 1280,
        "height": 653
      },
      "poi_business_url": "http://www.bv.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15245877116558125981&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "black--veatch",
      "poi_latitude": "38.9250015",
      "poi_longitude": "-94.6553624",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 913-458-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a1-2a31-70dc-aa19-9ba76e7d8c62.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-2a31-70dc-aa19-9ba76e7d8c62",
        "storage_key": "property/6767906449167622/019ff6a1-2a31-70dc-aa19-9ba76e7d8c62.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUyTe2TrqwIcRnSu0HXY8lNM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "consultant"
    },
    {
      "id": "custom_72bef499-62ee-4b97-8b5d-81ab8cbf99f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "Garmin",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1200 E 151st St, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a4-9c91-7586-b4b9-ee56fe8a0d2d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a4-9c91-7586-b4b9-ee56fe8a0d2d",
        "storage_key": "property/6767906449167622/019ff6a4-9c91-7586-b4b9-ee56fe8a0d2d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.garmin.com/en-US",
      "poi_directions_map_url": "https://maps.google.com/?cid=7856958804647333168&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "garmin",
      "poi_latitude": "38.8553721",
      "poi_longitude": "-94.7996464",
      "poi_miles_from_property": "9",
      "poi_walking_minutes": "3 hours 19 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 800-800-1020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a1-2a31-70dc-aa19-9ba76e7d8c62.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-2a31-70dc-aa19-9ba76e7d8c62",
        "storage_key": "property/6767906449167622/019ff6a1-2a31-70dc-aa19-9ba76e7d8c62.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmdY73mS-wIcRMM3hpWeGCW0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_65701308-4552-4e26-a347-74d77b7a5f73",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "Overland Park Regional Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "10500 Quivira Rd, Overland Park, KS 66215, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019fc994-aea6-701e-8113-e4ee3f8f307a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-aea6-701e-8113-e4ee3f8f307a",
        "storage_key": "property/6767906449167622/019fc994-aea6-701e-8113-e4ee3f8f307a.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://www.hcamidwest.com/locations/overland-park-regional-medical-center?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=13555409796355494155&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "overland-park-regional-medical-center",
      "poi_latitude": "38.9376197",
      "poi_longitude": "-94.7261812",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-541-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a1-2a43-73ad-bc19-1d6e418742d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-2a43-73ad-bc19-1d6e418742d2",
        "storage_key": "property/6767906449167622/019ff6a1-2a43-73ad-bc19-1d6e418742d2.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4cFCWJzAwIcRC5Ge4GN9Hrw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_7ee3a59f-632e-4f50-8473-5397be61904f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "Aspiria",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6140 Sprint Pkwy STE 125, Overland Park, KS 66211, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6bd-e244-727a-be3d-806ae00d3a4a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6bd-e244-727a-be3d-806ae00d3a4a",
        "storage_key": "property/6767906449167622/019ff6bd-e244-727a-be3d-806ae00d3a4a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://aspiriakc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6433786320914474865&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aspiria",
      "poi_latitude": "38.9169728",
      "poi_longitude": "-94.6568885",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-285-5800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a1-2a31-70dc-aa19-9ba76e7d8c62.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-2a31-70dc-aa19-9ba76e7d8c62",
        "storage_key": "property/6767906449167622/019ff6a1-2a31-70dc-aa19-9ba76e7d8c62.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP0ZxsczrwIcRceffOpJmSVk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_9b4b5c1e-9c29-41b6-9898-51b5afca24af",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "Menorah Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "5721 W 119th St, Overland Park, KS 66209, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019fc994-d279-7067-bfd4-1a595842d452.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-d279-7067-bfd4-1a595842d452",
        "storage_key": "property/6767906449167622/019fc994-d279-7067-bfd4-1a595842d452.webp",
        "width": 1280,
        "height": 983
      },
      "poi_business_url": "https://www.hcamidwest.com/locations/menorah-medical-center?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=13288974551408218760&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "menorah-medical-center",
      "poi_latitude": "38.9108041",
      "poi_longitude": "-94.6515422",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-498-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a1-2a43-73ad-bc19-1d6e418742d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-2a43-73ad-bc19-1d6e418742d2",
        "storage_key": "property/6767906449167622/019ff6a1-2a43-73ad-bc19-1d6e418742d2.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJa9T6FxnqwIcRiJLkTfLra7g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_da904529-45f7-4657-8f4f-5019ca0bbc77",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "Indian Creek Campus, The University of Kansas Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "10710 Nall Ave, Overland Park, KS 66211, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6bd-e161-755d-98ec-555cd742dd90.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6bd-e161-755d-98ec-555cd742dd90",
        "storage_key": "property/6767906449167622/019ff6bd-e161-755d-98ec-555cd742dd90.webp",
        "width": 1280,
        "height": 924
      },
      "poi_business_url": "https://www.kansashealthsystem.com/locations/indian-creek-the-university-of-kansas-hospital-overland-park-ks?utm_source=google_business_profile&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=12899780081359556560&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "indian-creek-campus-the-university-of-kansas-hospital",
      "poi_latitude": "38.93341340000001",
      "poi_longitude": "-94.6510538",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 913-588-1227",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a1-2a43-73ad-bc19-1d6e418742d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-2a43-73ad-bc19-1d6e418742d2",
        "storage_key": "property/6767906449167622/019ff6a1-2a43-73ad-bc19-1d6e418742d2.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJi_egESzqwIcR0I8YVqM5BbM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_da90295c-beaf-4140-8bab-37040ef3ae75",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "SMSD Center for Academic Achievement",
      "poi_type": "Education",
      "poi_address": "8200 W 71st St, Overland Park, KS 66204, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b671-d685-714f-8b60-483fea03e595.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b671-d685-714f-8b60-483fea03e595",
        "storage_key": "property/6767906449167622/01a0b671-d685-714f-8b60-483fea03e595.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.smsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13529336476659713433&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "smsd-center-for-academic-achievement",
      "poi_latitude": "39.0014907",
      "poi_longitude": "-94.6802101",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 43 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-993-6200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a1-2a3b-732c-a170-9b923823f5f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a1-2a3b-732c-a170-9b923823f5f1",
        "storage_key": "property/6767906449167622/019ff6a1-2a3b-732c-a170-9b923823f5f1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJF9r8VFzswIcRmYUJEtjbwbs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_dee1d50c-af69-472a-ad7a-68322d707973",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "custom",
      "poi_name": "Johnson County Administration Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "111 S Cherry St, Olathe, KS 66061, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a4-a413-74fd-92ea-7bf58f09c53e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a4-a413-74fd-92ea-7bf58f09c53e",
        "storage_key": "property/6767906449167622/019ff6a4-a413-74fd-92ea-7bf58f09c53e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.jocogov.org/contact-us/all-locations/administration-building",
      "poi_directions_map_url": "https://maps.google.com/?cid=15575052816225759890&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "johnson-county-administration-building",
      "poi_latitude": "38.8815028",
      "poi_longitude": "-94.8200342",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "3 hours 2 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 913-715-7400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/019ff6a4-ab19-77d8-bba8-795ab5a10df9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-ab19-77d8-bba8-795ab5a10df9",
        "storage_key": "property/6767906449167622/019ff6a4-ab19-77d8-bba8-795ab5a10df9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJc9_Fbvq9wIcRknIVJQS0Jdg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_d0b0eb189b184c08a5b3ddc3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "16:00"
    },
    {
      "id": "ec_84014f30db5f080b31c91314",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "day": "MON",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_0e32b381925581db1cfd9cfb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "day": "TUE",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_44d291844b1ddd08d68cd799",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "day": "WED",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_aae1253faf27ec7c2740b162",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "day": "THU",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_ffe2a88f6ec13d03d3fa0b9b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "day": "FRI",
      "open_time": "09:30",
      "close_time": "17:30"
    }
  ],
  "reviews": [
    {
      "id": "ec_e0cec2f1ebd24a662d55778c",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "rating": "5",
      "name": "Fausto Parral",
      "text": "I have absolutely loved my experience living here since my move in! The area is very beautiful and peaceful, as well as completely enveloped in nature. The office is full of friendly faces, such as the leasing agent Sheila. This a wonderful place to live and I highly recommend it to anyone who is looking for a tranquil living experience!",
      "date": "2026-06-17",
      "title": "false"
    },
    {
      "id": "ec_9fc8a69d1d8740cbf693fa18",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "rating": "5",
      "name": "Alexander Prince",
      "text": "The staff are fantastic from my experience, Sheila and Andrea have been friendly and helpful through the application and move in process. The complex has a great sound barrier to the highway, and is secluded and forested. Lots of birds and some deer for my cat to watch. A well maintained trail. Easy access to highways. There are higher number of bugs due to the trees.",
      "date": "2026-06-12",
      "title": "false"
    },
    {
      "id": "ec_5c3533c41dfca81bbe70a8ed",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "rating": "5",
      "name": "Mary Buyanovsky",
      "text": "I enjoyed my time at Waterford Place Apartments and Townhomes. Shout out to the ladies in the office!  Andrea, Angel and Sheila you are all awesome! Thank you for always making me and my fur babies feel welcome, safe and appreciated.\nAll requests were met in a timely and professional manner. And, always with a smile. The maintenance and ground crew did a great job keeping everything looking beautiful and working smoothly. Shout out to Brandon who is part of this crew. He always greeted me with a smile and asked how things were going. I would definitely recommend this apartment complex  to anyone looking to live in Overland Park.\nMary B.",
      "date": "2026-04-28",
      "title": "false"
    },
    {
      "id": "ec_6b409a888004a53e7fc64ef0",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "rating": "5",
      "name": "Calestis",
      "text": "I have been living here for a few months and so far just loving it.  The location only has one entrance giving it a safe and secluded feeling and yet I can still get on 435 in a couple minutes. The maintenence and management teams are both very friendly and eager to help you out within a day. If you have a dog there is a great path that follows Indian creek that goes through the woods and borders the property. Check them out if you are on the market for an apartment and want a great location.",
      "date": "2026-03-19",
      "title": "false"
    },
    {
      "id": "ec_795ec8dedca8b372715c02f4",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "rating": "5",
      "name": "Cristian Amaro",
      "text": "Nothing but positive experiences with the Waterford staff and living here as a whole. After mixed experiences at other complexes, it’s refreshing to have staff that care and engage with the community. Maintenance is prompt, the staff is kind and responsive, and the property is well maintained. While the units aren’t the most modern, any issues are handled quickly and professionally. This is a great complex if you're looking for a safe and quiet community. The walls do a great job of minimizing the noise from the highway.",
      "date": "2026-05-08",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_5b1a373f1ededf93528ac834",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b677-f6ec-71dc-ac14-ae31010248f9.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b677-f6ec-71dc-ac14-ae31010248f9",
        "storage_key": "property/6767906449167622/01a0b677-f6ec-71dc-ac14-ae31010248f9.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "The Strand",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=WQwVdsWDdrD"
    },
    {
      "id": "ec_c77fc9f68c166906670f268e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b677-c09a-7082-b251-3b1aa8ff7a21.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b677-c09a-7082-b251-3b1aa8ff7a21",
        "storage_key": "property/6767906449167622/01a0b677-c09a-7082-b251-3b1aa8ff7a21.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "The Oxford",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=7BHsuSgvjEz"
    },
    {
      "id": "ec_6e87e064784bacaa69d817ce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b677-c1a2-74af-8055-cba9779d59d5.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b677-c1a2-74af-8055-cba9779d59d5",
        "storage_key": "property/6767906449167622/01a0b677-c1a2-74af-8055-cba9779d59d5.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "The Covington",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=x5vn4m15Jaa"
    },
    {
      "id": "ec_8e3d810f2319b72802c01e23",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b677-e455-7508-9e11-1b65c94ec122.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b677-e455-7508-9e11-1b65c94ec122",
        "storage_key": "property/6767906449167622/01a0b677-e455-7508-9e11-1b65c94ec122.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "The Devonshire",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=FTQkMBKDgqP"
    },
    {
      "id": "ec_10b8a4eb149f84b08fbd19e1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167622/01a0b677-c63e-7454-9acb-174e60c83a36.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b677-c63e-7454-9acb-174e60c83a36",
        "storage_key": "property/6767906449167622/01a0b677-c63e-7454-9acb-174e60c83a36.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "The Waterford",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=YPfoLsqwncP"
    }
  ],
  "faqs": [
    {
      "id": "custom_421de237-152d-4fb4-9225-ad05702332c6",
      "question": "What are the qualifications for occupancy?",
      "answer": "Check our occupancy qualifications <a href=\"https://www.pricebrotherskc.com/ResidentialRentalQualifications/\">here</a>. We encourage everyone to apply, and hope to have you as a part of our community!",
      "category": "Rental Qualifications",
      "source": "custom"
    },
    {
      "id": "custom_5d4123d4-7a84-4b25-8603-88969412dfbb",
      "question": "What is the application fee and is it refundable?",
      "answer": "Application fees are due for each person 18 and older occupying the apartment. All application fees are nonrefundable.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_51ace36a-64f9-48b2-b21c-e6d125786b8d",
      "question": "How do I apply?",
      "answer": "Click on the <a href=\"/apply-now\">Apply Now</a> button under the <a href=\"/floor-plans\">Floor Plans</a> tab of our community website.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_aef5e49c-466a-4856-a9f9-d0decfe3216d",
      "question": "What is a holding deposit or earnest money?",
      "answer": "A \"holding\" deposit or \"earnest money\" is another word for \"security\" deposit. Please <a href=\"/contact-us\">contact our leasing office</a> for more details.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_b486e764-f059-4058-93e5-d587fbe9e373",
      "question": "Are there different lease term options available?",
      "answer": "Yes, we offer various lease term options. Please <a href=\"/contact-us\">contact our office</a> for more details.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_9ff9c73b-21fe-4bb1-ba36-8d4baa0f1dd4",
      "question": "Do I need an appointment to take a tour?",
      "answer": "No appointment is necessary to tour our community during business hours; however, it is always appreciated if you call ahead to make sure we are available to provide adequate time for you to tour and ask questions. It is recommended to arrive no later than one half hour prior to closing if you would like to tour the community. Everyone over 18 years of age must have a valid photo ID to tour. Valid forms of identification are decided by Price Brothers Management Company and may include items such as: US Driver’s License, US State Photo ID, US Military Photo ID, US Visa with Photo ID upon it, US Citizenship and Immigration Services Photo ID, Passport.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_8171d319-db01-4f8e-b18a-30744166ef75",
      "question": "Do you allow pets?",
      "answer": "Our community is happy to accept cats and dogs. Please refer to our pet section on the <a href=\"/pet-policy\">Pet Policy</a> page.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_c4ba48ee-eab5-4552-8662-0c189be1b053",
      "question": "What utilities am I responsible to pay?",
      "answer": "Our residents are responsible to pay for water, trash, electric and gas.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_c2be8147-f1e2-4f5d-aa70-69ea2470b7a7",
      "question": "Why does your pricing include ranges?",
      "answer": "The prices will range on each floor plan depending on finishes, views, and other features inside the apartment home.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_5c46dcdd-bfab-4cc5-a4d1-d606aa5fccff",
      "question": "Do you require renters insurance?",
      "answer": "All residents are required to maintain a minimum of $100,000 in liability coverage as part of their lease agreement. For more details on coverage requirements and available options, please <a href=\"/contact-us\">contact our leasing office</a>.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_6d74be18-1d54-488b-857d-e33772709976",
      "question": "How can I refer a friend?",
      "answer": "If you love living here and want to refer a friend, please let our office know! We offer resident referral programs throughout the year and would love for your friends and family to join our community.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_2a3d209f-ea5a-4d1c-bc0a-b45fb66bcf2a",
      "question": "How can I pay my rent?",
      "answer": "You can pay rent by accessing your <a href=\"/resident-access\">resident online account</a>. This allows you to use a bank account or credit card to make payments.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_a4ed9dc3-96ac-409e-b5f9-c4832fc6964d",
      "question": "Do you offer flexible rent payment options?",
      "answer": "Yes! We’ve partnered with Flex to make paying rent easier for our residents. Flex allows you to split your rent into smaller, more manageable payments throughout the month, giving you added financial flexibility. For more details or to sign up, <a href=\"/contact-us\">contact our leasing office</a> today!",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_ad0ca722-f038-45f2-a0c6-84c7cc319c33",
      "question": "Do you offer covered parking?",
      "answer": "Yes, we offer carports for rent. Please <a href=\"/contact-us\">contact the office</a> for our most current carport availability.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_b657815b-36fb-4fb3-bdcf-182a37cf1d86",
      "question": "Do you host events at your property?",
      "answer": "Yes, we host events throughout the year with various activities to encourage community camaraderie.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_51716750-f1d4-4658-a568-ae2a95e0e455",
      "question": "Do you accept packages on behalf of the residents?",
      "answer": "No, we do not offer this service at this time.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_f51a810c-e6fa-4a67-96a7-c3addd1f1c16",
      "question": "If something needs to be repaired in my apartment, how do I report it?",
      "answer": "You may call the office or submit work orders online by accessing your <a href=\"/resident-access\">resident account</a>. All emergency repairs should be reported by <a href=\"/contact-us\">contacting the office</a>. If the emergency is being reported after business hours, please follow the prompts to be connected to the answering service.",
      "category": "Maintenance",
      "source": "custom"
    }
  ],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01a0c9ac-4d06-7203-87c3-66f20ca1d134",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Waterford Place Apartments & Townhomes Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622"
    },
    {
      "lead_collector_id": "01a0c9ac-4d8f-767f-b250-dff98e0ea883",
      "lead_source": "LANDING_PAGE",
      "name": "Waterford Place Apartments & Townhomes Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "generator",
      "page_item_url": "apartments-in-unit-laundry-overland-park",
      "search_query": "apartments with in-unit laundry Overland Park KS",
      "category": "Amenity",
      "h1_title": "In-Unit Laundry Apartments Overland Park",
      "h2_subtitle": "Discover Waterford Place Apartments featuring the convenience of in-unit laundry. Located in Overland Park KS, enjoy comfortable living and modern amenities.",
      "page_copy": "Located in the lush greenery of Overland Park, Waterford Place Apartments & Townhomes offer modern living with the comfort of in-unit laundry. Enjoy one- and two-bedroom units in a non-smoking community designed for convenience and style. \n\nNestled in a parklike setting, Waterford Place provides access to nature trails, a pool, and BBQ grills amidst the serene neighborhood of Outlying Johnson County KS. Experience practical home features alongside scenic beauty and easy access across the county. Join us for a tour and explore your new home today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167622/019fc991-babb-7198-9763-2fc10d5102b7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a kidney-shaped swimming pool with lounge chairs and umbrellas, adjacent to a building with a deck.",
        "public_id": "019fc991-babb-7198-9763-2fc10d5102b7",
        "storage_key": "property/6767906449167622/019fc991-babb-7198-9763-2fc10d5102b7.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apartments Overland Park",
      "seo_description": "Explore Waterford Place with in-unit laundry. Nestled in Overland Park KS, enjoy modern living and amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "generator",
      "page_item_url": "air-conditioned-townhomes-outlying-johnson-county",
      "search_query": "air conditioned townhomes Outlying Johnson County KS",
      "category": "Amenity",
      "h1_title": "Air Conditioned Townhomes in Johnson County",
      "h2_subtitle": "Explore air conditioned townhomes at Waterford Place. Nestled in Outlying Johnson County KS, enjoy comfort and connectivity in Overland Park.",
      "page_copy": "Stay cool and comfortable at Waterford Place Apartments & Townhomes, featuring air conditioned townhomes in the serene Outlying Johnson County KS. With easy access to nature trails and modern amenities, our community offers a refreshing retreat in a parklike setting.\n\nWaterford Place offers more than just air conditioned spaces; elevate your lifestyle with our cozy wood-burning fireplaces, community pool, and outdoor BBQ grills. Perfect for those who appreciate convenience and comfort in a location that connects you effortlessly across Overland Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167622/019fc991-babb-7198-9763-2fc10d5102b7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a kidney-shaped swimming pool with lounge chairs and umbrellas, adjacent to a building with a deck.",
        "public_id": "019fc991-babb-7198-9763-2fc10d5102b7",
        "storage_key": "property/6767906449167622/019fc991-babb-7198-9763-2fc10d5102b7.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Townhomes Johnson County",
      "seo_description": "Discover air conditioned townhomes at Waterford Place. Located in Outlying Johnson County KS, enjoy comfort and connectivity.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "generator",
      "page_item_url": "apartments-with-pool-johnson-county",
      "search_query": "apartments with pool access Johnson County KS",
      "category": "Amenity",
      "h1_title": "Pool Access Apartments in Johnson County",
      "h2_subtitle": "Discover Waterford Place Apartments with refreshing pool access. Located in the heart of Johnson County KS, enjoy leisure and connectivity.",
      "page_copy": "Waterford Place Apartments & Townhomes invites you to relax with our exclusive pool access in the tranquil surroundings of Johnson County KS. Whether you prefer swimming laps or lounging poolside, our community caters to all your leisure needs.\n\nIn addition to pool relaxation, enjoy the beauty of nature trails and parklike scenery just steps from your door. Our well-designed one- and two-bedroom homes are complete with fireplaces and picnic areas, offering you both comfort and convenience in vibrant Overland Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167622/019fc991-babb-7198-9763-2fc10d5102b7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a kidney-shaped swimming pool with lounge chairs and umbrellas, adjacent to a building with a deck.",
        "public_id": "019fc991-babb-7198-9763-2fc10d5102b7",
        "storage_key": "property/6767906449167622/019fc991-babb-7198-9763-2fc10d5102b7.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pool Access Apartments Johnson County KS",
      "seo_description": "Enjoy Waterford Place Apartments with pool access in Johnson County KS. Live in comfort and style in Overland Park.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "generator",
      "page_item_url": "overland-park-apartments-nature-trails",
      "search_query": "Overland Park KS apartments with nature trails",
      "category": "Amenity",
      "h1_title": "Apartments with Nature Trails in Overland Park",
      "h2_subtitle": "Explore Waterford Place for apartments with nature trails at your doorstep. Experience the serene environment of Overland Park KS.",
      "page_copy": "Immerse yourself in nature at Waterford Place Apartments & Townhomes, where nature trails weave through the lush landscapes of Overland Park KS. Our community promotes a peaceful lifestyle surrounded by greenery, offering residents a perfect balance of comfort and adventure.\n\nLocated in Outlying Johnson County KS, Waterford Place offers a serene escape with easy access to modern conveniences. In addition to nature trails, enjoy amenities such as a pool, BBQ grills, and cozy fireplaces. Discover the tranquility and community spirit that make Waterford Place a unique living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167622/019fc991-babb-7198-9763-2fc10d5102b7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a kidney-shaped swimming pool with lounge chairs and umbrellas, adjacent to a building with a deck.",
        "public_id": "019fc991-babb-7198-9763-2fc10d5102b7",
        "storage_key": "property/6767906449167622/019fc991-babb-7198-9763-2fc10d5102b7.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Nature Trail Apartments Overland Park KS",
      "seo_description": "Discover Waterford Place in Overland Park KS, featuring nature trail access. Enjoy modern comfort and serene living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-overland-park-66210",
      "search_query": "pet-friendly apartments in Overland Park 66210",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments in Overland Park",
      "h2_subtitle": "Welcome to Waterford Place, where pet-friendly apartments meet unmatched comfort. Discover Overland Park living in the 66210 area.",
      "page_copy": "At Waterford Place Apartments & Townhomes, we understand that pets are family too. Our pet-friendly community in Overland Park 66210 ensures that both you and your furry companions feel right at home. With expansive grounds and nearby nature trails, your pets will love living here as much as you do.\n\nEnjoy a lifestyle filled with conveniences and connections, from cozy fireplaces and pool access to BBQ grilling areas perfect for outdoor gatherings. Located in Johnson County, our vibrant community combines the best of natural beauty and modern amenities, ensuring a fulfilling living experience for all.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167622/019fc991-babb-7198-9763-2fc10d5102b7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a kidney-shaped swimming pool with lounge chairs and umbrellas, adjacent to a building with a deck.",
        "public_id": "019fc991-babb-7198-9763-2fc10d5102b7",
        "storage_key": "property/6767906449167622/019fc991-babb-7198-9763-2fc10d5102b7.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments Overland Park 66210",
      "seo_description": "Waterford Place offers pet-friendly apartments in Overland Park 66210. Enjoy a welcoming community with nature trails and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-overland-park",
      "search_query": "one bedroom apartments in Overland Park KS",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Overland Park",
      "h2_subtitle": "Explore our stylish one-bedroom apartments in Overland Park KS. Waterford Place offers the perfect blend of comfort and convenience.",
      "page_copy": "Discover the perfect one-bedroom apartment at Waterford Place Apartments & Townhomes in Overland Park KS. Our thoughtfully designed living spaces provide comfort and modern amenities, ideal for singles or couples looking for a cozy home.\n\nLocated in the scenic Outlying Johnson County, each apartment offers easy access to nature trails, a community pool, and inviting BBQ areas. With a charming parklike setting and a community-focused lifestyle, Waterford Place is where you can enjoy both relaxation and connectivity in a vibrant neighborhood.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167622/019fc991-babb-7198-9763-2fc10d5102b7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a kidney-shaped swimming pool with lounge chairs and umbrellas, adjacent to a building with a deck.",
        "public_id": "019fc991-babb-7198-9763-2fc10d5102b7",
        "storage_key": "property/6767906449167622/019fc991-babb-7198-9763-2fc10d5102b7.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments Overland Park KS",
      "seo_description": "Find ideal one-bedroom apartments in Overland Park KS at Waterford Place. Enjoy modern amenities in a picturesque setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "generator",
      "page_item_url": "two-bedroom-townhomes-johnson-county",
      "search_query": "two bedroom townhomes in Johnson County KS",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Townhomes in Johnson County",
      "h2_subtitle": "Waterford Place offers spacious two-bedroom townhomes with modern amenities in Johnson County KS—a perfect blend of comfort and convenience.",
      "page_copy": "Experience spacious living in our two-bedroom townhomes at Waterford Place Apartments & Townhomes, located in the heart of Johnson County KS. These townhomes provide ample space, perfect for families or roommates, and are designed with both style and functionality in mind.\n\nOur community invites you to explore a range of amenities including nature trails, a sparkling pool, and BBQ areas for social gatherings. Nestled in a tranquil setting, Waterford Place connects you effortlessly to the vibrant surroundings of Overland Park, ensuring you enjoy both peace and community living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167622/019fc991-babb-7198-9763-2fc10d5102b7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a kidney-shaped swimming pool with lounge chairs and umbrellas, adjacent to a building with a deck.",
        "public_id": "019fc991-babb-7198-9763-2fc10d5102b7",
        "storage_key": "property/6767906449167622/019fc991-babb-7198-9763-2fc10d5102b7.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Townhomes Johnson County KS",
      "seo_description": "Discover spacious two-bedroom townhomes at Waterford Place in Johnson County KS. Enjoy modern living with top-notch amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "generator",
      "page_item_url": "apartments-near-indian-valley-elementary",
      "search_query": "apartments near Indian Valley Elementary School Overland Park",
      "category": "School",
      "h1_title": "Apartments Near Indian Valley Elementary",
      "h2_subtitle": "Find the perfect home at Waterford Place, located near Indian Valley Elementary School in Overland Park. Enjoy convenience and community living.",
      "page_copy": "Waterford Place Apartments & Townhomes offers a prime location for families, being conveniently situated near Indian Valley Elementary School in Overland Park. Our community provides easy access to quality education and offers a welcoming environment for both relaxation and socialization.\n\nEnjoy amenities like our picturesque pool, cozy fireplaces, and BBQ areas perfect for family gatherings. Our one and two-bedroom layouts provide comfortable living spaces designed to suit a variety of lifestyles, making Waterford Place an ideal choice for those who prioritize proximity to top-notch schools and vibrant neighborhood living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167622/019fc991-babb-7198-9763-2fc10d5102b7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a kidney-shaped swimming pool with lounge chairs and umbrellas, adjacent to a building with a deck.",
        "public_id": "019fc991-babb-7198-9763-2fc10d5102b7",
        "storage_key": "property/6767906449167622/019fc991-babb-7198-9763-2fc10d5102b7.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Indian Valley Elementary Overland Park",
      "seo_description": "Find apartments near Indian Valley Elementary in Overland Park at Waterford Place. Enjoy community living with excellent amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "generator",
      "page_item_url": "waterford-place-near-johnson-county-college",
      "search_query": "Waterford Place near Johnson County Community College",
      "category": "School",
      "h1_title": "Waterford Place Near Johnson County College",
      "h2_subtitle": "Enjoy convenience and comfort at Waterford Place, located near Johnson County Community College. Ideal for students and faculty alike.",
      "page_copy": "Discover the ease of living close to Johnson County Community College at Waterford Place Apartments & Townhomes. Located just a short drive from the college, our community is perfect for students, faculty, and staff seeking comfortable, accessible living options.\n\nOur one and two-bedroom apartments and townhomes offer modern amenities such as a swimming pool, cozy fireplaces, and BBQ areas. With its prime location in Overland Park, Waterford Place ensures you can focus on your academic goals while enjoying a supportive and engaging community environment.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167622/019fc991-babb-7198-9763-2fc10d5102b7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a kidney-shaped swimming pool with lounge chairs and umbrellas, adjacent to a building with a deck.",
        "public_id": "019fc991-babb-7198-9763-2fc10d5102b7",
        "storage_key": "property/6767906449167622/019fc991-babb-7198-9763-2fc10d5102b7.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Waterford Place Near Johnson County Community College",
      "seo_description": "Live near Johnson County Community College at Waterford Place. Perfect for students and faculty, offering great amenities and location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "generator",
      "page_item_url": "shawnee-mission-south-high-school-apartments",
      "search_query": "Shawnee Mission South High School apartments Overland Park",
      "category": "School",
      "h1_title": "Apartments Near Shawnee Mission South High",
      "h2_subtitle": "Find ideal living at Waterford Place, located conveniently near Shawnee Mission South High School in Overland Park. Embrace the convenience and community.",
      "page_copy": "Waterford Place Apartments & Townhomes is perfectly positioned for families with students enrolled at Shawnee Mission South High School in Overland Park. Our community offers an ideal blend of convenience and comfort, making it a top choice for those looking to live near top educational facilities.\n\nFeaturing one and two-bedroom options, our homes come with amenities such as a non-smoking environment, a refreshing pool, and picnic areas with BBQ grills. Residents will appreciate easy access to all that Overland Park has to offer while enjoying a peaceful, supportive community. Become a part of Waterford Place, where education and lifestyle merge seamlessly.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167622/019fc991-babb-7198-9763-2fc10d5102b7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a kidney-shaped swimming pool with lounge chairs and umbrellas, adjacent to a building with a deck.",
        "public_id": "019fc991-babb-7198-9763-2fc10d5102b7",
        "storage_key": "property/6767906449167622/019fc991-babb-7198-9763-2fc10d5102b7.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Shawnee Mission South High School Apartments",
      "seo_description": "Live near Shawnee Mission South High School at Waterford Place in Overland Park. Perfect for families seeking convenience and comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "generator",
      "page_item_url": "saint-thomas-aquinas-high-school-apartments",
      "search_query": "Saint Thomas Aquinas High School nearby apartments",
      "category": "School",
      "h1_title": "Nearby Apartments to Saint Thomas Aquinas High",
      "h2_subtitle": "Explore prime apartment living at Waterford Place, just minutes from Saint Thomas Aquinas High School. Perfect for students and families.",
      "page_copy": "Located just a short distance from Saint Thomas Aquinas High School, Waterford Place Apartments & Townhomes is an excellent choice for those seeking convenient and comfortable living in Overland Park. Our community offers easy access to education and local amenities.\n\nFeaturing stylish one and two-bedroom apartments and townhomes, Waterford Place boasts amenities like a serene swimming pool, inviting fireplaces, and picnic areas with BBQ grills. Enjoy a community that supports both academic and personal well-being, making it a fantastic option for students and families looking to live near Saint Thomas Aquinas High School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167622/019fc991-babb-7198-9763-2fc10d5102b7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a kidney-shaped swimming pool with lounge chairs and umbrellas, adjacent to a building with a deck.",
        "public_id": "019fc991-babb-7198-9763-2fc10d5102b7",
        "storage_key": "property/6767906449167622/019fc991-babb-7198-9763-2fc10d5102b7.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Saint Thomas Aquinas High School Nearby Apartments",
      "seo_description": "Discover apartments near Saint Thomas Aquinas High School at Waterford Place. Ideal for students and families seeking convenience and comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "generator",
      "page_item_url": "overland-park-apartments-near-oak-park-carpenter-school",
      "search_query": "Overland Park apartments near Oak Park-Carpenter Elementary School",
      "category": "School",
      "h1_title": "Apartments Near Oak Park-Carpenter Elementary",
      "h2_subtitle": "Discover family-friendly living close to Oak Park-Carpenter Elementary School at Waterford Place Apartments, nestled in Overland Park.",
      "page_copy": "Waterford Place Apartments & Townhomes offers the ideal setting for families looking to reside near Oak Park-Carpenter Elementary School in Overland Park. Our community provides a harmonious environment that's perfect for nurturing young families.\n\nWith one and two-bedroom apartments and townhomes available, residents can enjoy amenities like a non-smoking community, a comfortable pool area, and picnic spots featuring BBQ grills. Waterford Place combines convenience, comfort, and a supportive atmosphere, making it the perfect home base for families with children at Oak Park-Carpenter Elementary.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167622/019fc991-babb-7198-9763-2fc10d5102b7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a kidney-shaped swimming pool with lounge chairs and umbrellas, adjacent to a building with a deck.",
        "public_id": "019fc991-babb-7198-9763-2fc10d5102b7",
        "storage_key": "property/6767906449167622/019fc991-babb-7198-9763-2fc10d5102b7.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Overland Park Apartments Near Oak Park-Carpenter",
      "seo_description": "Find apartments near Oak Park-Carpenter Elementary School at Waterford Place. Ideal for families seeking comfort in Overland Park.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "generator",
      "page_item_url": "indian-woods-middle-school-apartments-johnson-county",
      "search_query": "Indian Woods Middle School apartments in Johnson County",
      "category": "School",
      "h1_title": "Apartments Near Indian Woods Middle School",
      "h2_subtitle": "Live close to Indian Woods Middle School at Waterford Place, ideally located in Johnson County's Overland Park.",
      "page_copy": "Waterford Place Apartments & Townhomes offers a prime location for families with students at Indian Woods Middle School in Johnson County. Nestled in the heart of Overland Park, our community is designed to provide convenient and welcoming living spaces.\n\nChoose from our selection of one and two-bedroom homes, each equipped with cozy features like wood-burning fireplaces and access to a refreshing pool. Enjoy the beautiful outdoor settings with picnic areas and BBQ grills. Waterford Place ensures easy access to the school and a comfortable community atmosphere for families.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167622/019fc991-babb-7198-9763-2fc10d5102b7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a kidney-shaped swimming pool with lounge chairs and umbrellas, adjacent to a building with a deck.",
        "public_id": "019fc991-babb-7198-9763-2fc10d5102b7",
        "storage_key": "property/6767906449167622/019fc991-babb-7198-9763-2fc10d5102b7.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Indian Woods Middle School Apartments Johnson County",
      "seo_description": "Find convenient apartments near Indian Woods Middle School at Waterford Place, located in Johnson County's Overland Park.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "generator",
      "page_item_url": "university-of-kansas-edwards-campus-apartments",
      "search_query": "University of Kansas Edwards Campus nearby apartments KS",
      "category": "School",
      "h1_title": "Apartments Near KU Edwards Campus",
      "h2_subtitle": "Discover convenient living at Waterford Place, just minutes from the University of Kansas Edwards Campus in Overland Park, KS.",
      "page_copy": "Waterford Place Apartments & Townhomes is the perfect choice for those looking to live near the University of Kansas Edwards Campus in Overland Park, KS. Our community offers a blend of comfort and convenience tailored to meet the needs of students and faculty alike.\n\nOur one and two-bedroom apartments and townhomes are thoughtfully designed with features like cozy fireplaces and a serene pool area. Students and staff at KU Edwards Campus will appreciate the non-smoking environment and amenities such as picnic areas with BBQ grills, providing the perfect balance between leisure and convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167622/019fc991-babb-7198-9763-2fc10d5102b7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a kidney-shaped swimming pool with lounge chairs and umbrellas, adjacent to a building with a deck.",
        "public_id": "019fc991-babb-7198-9763-2fc10d5102b7",
        "storage_key": "property/6767906449167622/019fc991-babb-7198-9763-2fc10d5102b7.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "KU Edwards Campus Nearby Apartments KS",
      "seo_description": "Explore apartments near the University of Kansas Edwards Campus at Waterford Place, offering ideal living in Overland Park, KS.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "generator",
      "page_item_url": "apartments-near-childrens-mercy-kansas-overland-park",
      "search_query": "apartments near children's mercy kansas overland park",
      "category": "Hospital",
      "h1_title": "Apartments Near Children's Mercy Kansas",
      "h2_subtitle": "Find cozy living at Waterford Place Apartments, conveniently located near Children's Mercy Kansas in Overland Park.",
      "page_copy": "Waterford Place Apartments & Townhomes offers a peaceful residential experience for those working or visiting Children's Mercy Kansas in Overland Park. Our community provides an ideal mix of comfort and accessibility, perfectly situated for healthcare professionals and families alike.\n\nChoose from our array of one and two-bedroom apartments and townhomes, featuring amenities like inviting wood-burning fireplaces and a refreshing pool. Enjoy the lush outdoor spaces with picnic tables and BBQ grills, all within a short drive to Children's Mercy Kansas, making Waterford Place a fantastic choice for convenient living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167622/019fc991-babb-7198-9763-2fc10d5102b7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a kidney-shaped swimming pool with lounge chairs and umbrellas, adjacent to a building with a deck.",
        "public_id": "019fc991-babb-7198-9763-2fc10d5102b7",
        "storage_key": "property/6767906449167622/019fc991-babb-7198-9763-2fc10d5102b7.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Children's Mercy in Overland Park",
      "seo_description": "Discover apartments near Children's Mercy Kansas at Waterford Place, offering ideal living in Overland Park.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "generator",
      "page_item_url": "overland-park-regional-medical-center-apartments",
      "search_query": "overland park regional medical center nearby apartments",
      "category": "Hospital",
      "h1_title": "Apartments Near Overland Park Regional Medical",
      "h2_subtitle": "Experience convenient living at Waterford Place, just minutes away from Overland Park Regional Medical Center.",
      "page_copy": "At Waterford Place Apartments & Townhomes, find the perfect blend of comfort and convenience just a short distance from Overland Park Regional Medical Center. Our location is ideal for healthcare professionals seeking nearby accommodation or families wanting close proximity to essential healthcare services.\n\nOur selection of one and two-bedroom apartments and townhomes offer modern comforts such as wood-burning fireplaces and access to a community pool. Enjoy outdoor amenities like picnic tables with BBQ grills in a tranquil setting, making Waterford Place a great option for those looking for relaxing yet convenient living near Overland Park Regional Medical Center.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167622/019fc991-babb-7198-9763-2fc10d5102b7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a kidney-shaped swimming pool with lounge chairs and umbrellas, adjacent to a building with a deck.",
        "public_id": "019fc991-babb-7198-9763-2fc10d5102b7",
        "storage_key": "property/6767906449167622/019fc991-babb-7198-9763-2fc10d5102b7.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Overland Park Regional Medical Center Apartments",
      "seo_description": "Find nearby apartments at Waterford Place, ideal for those near Overland Park Regional Medical Center in KS.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "generator",
      "page_item_url": "apartments-near-indian-creek-campus-ku-hospital",
      "search_query": "apartments close to indian creek campus the university of kansas hospital johnson county",
      "category": "Hospital",
      "h1_title": "Apartments Near Indian Creek Campus KU Hospital",
      "h2_subtitle": "Explore convenient living options at Waterford Place, located close to Indian Creek Campus of The University of Kansas Hospital.",
      "page_copy": "Waterford Place Apartments & Townhomes offers an ideal living environment for those seeking proximity to the Indian Creek Campus of The University of Kansas Hospital in Johnson County. Our community is thoughtfully designed to cater to the needs of hospital staff, patients, and their families who require nearby accommodation.\n\nSelect from our cozy one and two-bedroom apartments and townhomes, where you can enjoy features like wood-burning fireplaces and a refreshing pool. Our community's non-smoking policy, along with picnic areas equipped with BBQ grills, ensures a pleasant living experience close to the Indian Creek Campus, making Waterford Place an excellent choice.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167622/019fc991-babb-7198-9763-2fc10d5102b7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a kidney-shaped swimming pool with lounge chairs and umbrellas, adjacent to a building with a deck.",
        "public_id": "019fc991-babb-7198-9763-2fc10d5102b7",
        "storage_key": "property/6767906449167622/019fc991-babb-7198-9763-2fc10d5102b7.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Indian Creek Campus KU Hospital",
      "seo_description": "Discover nearby apartments at Waterford Place, perfect for those near Indian Creek Campus of KU Hospital in Johnson County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "generator",
      "page_item_url": "apartments-near-overland-park-arboretum-botanical-gardens",
      "search_query": "apartments near overland park arboretum & botanical gardens",
      "category": "Park",
      "h1_title": "Apartments Near Overland Park Arboretum",
      "h2_subtitle": "Discover nature-inspired living at Waterford Place, located conveniently near Overland Park Arboretum & Botanical Gardens.",
      "page_copy": "Embrace a lifestyle intertwined with nature at Waterford Place Apartments & Townhomes, located just a short drive from the Overland Park Arboretum & Botanical Gardens. Our community is perfect for nature enthusiasts wishing to explore the stunning landscapes and trails of the arboretum.\n\nOur one and two-bedroom apartments and townhomes offer modern amenities like a wood-burning fireplace and access to a refreshing pool. Enjoy community features including picnic tables and BBQ grills, all set in a lush, parklike environment. Waterford Place ensures a serene and convenient living experience near the Overland Park Arboretum & Botanical Gardens.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167622/019fc991-babb-7198-9763-2fc10d5102b7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a kidney-shaped swimming pool with lounge chairs and umbrellas, adjacent to a building with a deck.",
        "public_id": "019fc991-babb-7198-9763-2fc10d5102b7",
        "storage_key": "property/6767906449167622/019fc991-babb-7198-9763-2fc10d5102b7.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Overland Park Arboretum",
      "seo_description": "Live near nature at Waterford Place, ideal for those seeking proximity to Overland Park Arboretum & Botanical Gardens.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "generator",
      "page_item_url": "waterford-place-near-valleybrooke-park",
      "search_query": "waterford place close to valleybrooke park",
      "category": "Park",
      "h1_title": "Waterford Place by Valleybrooke Park",
      "h2_subtitle": "Enjoy the best of both worlds at Waterford Place, situated near the serene Valleybrooke Park.",
      "page_copy": "Find your new home at Waterford Place Apartments & Townhomes, conveniently located near the tranquility of Valleybrooke Park. Living here means easy access to lush green spaces and scenic paths, making it perfect for those who love spending time outdoors.\n\nOur selection of one and two-bedroom apartments and townhomes offer cozy features such as wood-burning fireplaces and community amenities like a sparkling pool and picnic areas with BBQ grills. Waterford Place combines the serenity of Valleybrooke Park with modern living, providing an exceptional lifestyle in Overland Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167622/019fc991-babb-7198-9763-2fc10d5102b7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a kidney-shaped swimming pool with lounge chairs and umbrellas, adjacent to a building with a deck.",
        "public_id": "019fc991-babb-7198-9763-2fc10d5102b7",
        "storage_key": "property/6767906449167622/019fc991-babb-7198-9763-2fc10d5102b7.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Waterford Place by Valleybrooke Park",
      "seo_description": "Discover Waterford Place, just steps away from Valleybrooke Park, offering a perfect blend of comfort and nature.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "generator",
      "page_item_url": "shannon-valley-park-nearby-apartments",
      "search_query": "shannon valley park nearby apartments",
      "category": "Park",
      "h1_title": "Apartments Near Shannon Valley Park",
      "h2_subtitle": "Experience comfortable living at Waterford Place, conveniently close to Shannon Valley Park.",
      "page_copy": "Enjoy living just minutes from Shannon Valley Park at Waterford Place Apartments & Townhomes, where lush landscapes and serene settings meet modern conveniences. Our community provides easy access to this beautiful park, ideal for those who enjoy outdoor activities and leisurely walks.\n\nChoose from our thoughtfully designed one and two-bedroom apartments and townhomes featuring cozy fireplaces and a refreshing pool. With amenities like picnic areas with BBQ grills, Waterford Place offers a welcoming environment, making it a top choice for those seeking nearby apartments to Shannon Valley Park in Overland Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167622/019fc991-babb-7198-9763-2fc10d5102b7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a kidney-shaped swimming pool with lounge chairs and umbrellas, adjacent to a building with a deck.",
        "public_id": "019fc991-babb-7198-9763-2fc10d5102b7",
        "storage_key": "property/6767906449167622/019fc991-babb-7198-9763-2fc10d5102b7.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Shannon Valley Park",
      "seo_description": "Find your perfect home at Waterford Place, located near Shannon Valley Park, offering comfort and convenience in Overland Park.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "generator",
      "page_item_url": "living-near-cobblestone-park-overland-park",
      "search_query": "living near cobblestone park overland park",
      "category": "Park",
      "h1_title": "Living Near Cobblestone Park",
      "h2_subtitle": "Embrace community living at Waterford Place, conveniently located near Cobblestone Park in Overland Park.",
      "page_copy": "Discover a vibrant lifestyle at Waterford Place Apartments & Townhomes, perfectly situated near Cobblestone Park in Overland Park. Experience the best of both worlds with nature trails and community amenities that cater to a comfortable and active lifestyle.\n\nOur apartments and townhomes offer spacious floor plans and cozy features such as wood-burning fireplaces. Enjoy community amenities like a sparkling pool and BBQ grills, perfect for socializing. Living near Cobblestone Park, Waterford Place provides convenient access to outdoor fun while ensuring modern comfort and convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167622/019fc991-babb-7198-9763-2fc10d5102b7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a kidney-shaped swimming pool with lounge chairs and umbrellas, adjacent to a building with a deck.",
        "public_id": "019fc991-babb-7198-9763-2fc10d5102b7",
        "storage_key": "property/6767906449167622/019fc991-babb-7198-9763-2fc10d5102b7.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Near Cobblestone Park",
      "seo_description": "Explore Waterford Place, ideally located near Cobblestone Park, offering comfort and outdoor access in Overland Park.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "generator",
      "page_item_url": "corporate-woods-founders-park-neighborhood",
      "search_query": "corporate woods founders park neighborhood residences",
      "category": "Park",
      "h1_title": "Residences in Founders Park Neighborhood",
      "h2_subtitle": "Discover Waterford Place, nestled in the Founders Park neighborhood, close to Corporate Woods.",
      "page_copy": "Waterford Place Apartments & Townhomes offers an ideal location in the Founders Park neighborhood, just moments from Corporate Woods. Our vibrant community provides exceptional living options and a welcoming environment tailored towards professionals and families alike.\n\nOur one and two-bedroom apartments and townhomes feature cozy fireplaces and modern amenities, including a pool and BBQ areas. With beautiful landscaping and proximity to Corporate Woods, Waterford Place is perfectly situated for both work and leisure. Experience the charm of living in the Founders Park neighborhood today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167622/019fc991-babb-7198-9763-2fc10d5102b7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a kidney-shaped swimming pool with lounge chairs and umbrellas, adjacent to a building with a deck.",
        "public_id": "019fc991-babb-7198-9763-2fc10d5102b7",
        "storage_key": "property/6767906449167622/019fc991-babb-7198-9763-2fc10d5102b7.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Residences in Founders Park Neighborhood",
      "seo_description": "Explore Waterford Place, near Corporate Woods, in the Founders Park neighborhood offering a perfect blend of work and leisure.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "generator",
      "page_item_url": "apartments-near-tomahawk-park-johnson-county",
      "search_query": "apartments near tomahawk park johnson county",
      "category": "Park",
      "h1_title": "Apartments Near Tomahawk Park",
      "h2_subtitle": "Enjoy modern living at Waterford Place, conveniently located near Tomahawk Park in Johnson County.",
      "page_copy": "Settle into comfort at Waterford Place Apartments & Townhomes, located in close proximity to Tomahawk Park in Johnson County. Our community offers the perfect blend of nature and convenience, ensuring a serene living environment with easy access to one of the area's most cherished parks.\n\nOur spacious one and two-bedroom apartments and townhomes boast features like cozy fireplaces and picturesque surroundings. Community amenities, such as a pool and picnic spaces, enhance the lifestyle. Discover why Waterford Place is a top choice for those seeking apartments near Tomahawk Park in Johnson County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167622/019fc991-babb-7198-9763-2fc10d5102b7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a kidney-shaped swimming pool with lounge chairs and umbrellas, adjacent to a building with a deck.",
        "public_id": "019fc991-babb-7198-9763-2fc10d5102b7",
        "storage_key": "property/6767906449167622/019fc991-babb-7198-9763-2fc10d5102b7.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Tomahawk Park",
      "seo_description": "Choose Waterford Place, ideally situated near Tomahawk Park, providing a balance of nature and modern living in Johnson County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "generator",
      "page_item_url": "residences-close-to-quivira-park-66210",
      "search_query": "residences close to quivira park 66210",
      "category": "Park",
      "h1_title": "Residences Near Quivira Park",
      "h2_subtitle": "Live in comfort at Waterford Place, conveniently located near Quivira Park in the 66210 area.",
      "page_copy": "Discover the ideal residence at Waterford Place Apartments & Townhomes, located just a short distance from Quivira Park in the 66210 area. Our community offers beautifully designed living spaces in a serene setting, perfect for connecting with both nature and urban amenities.\n\nEnjoy the best of apartment living with our one and two-bedroom options, complemented by amenities like ambient wood-burning fireplaces and a community pool. Access to Quivira Park opens up a world of recreational activities right on your doorstep, making Waterford Place a prime choice for those seeking a vibrant living experience close to parkland in the 66210 locale.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167622/019fc991-babb-7198-9763-2fc10d5102b7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a kidney-shaped swimming pool with lounge chairs and umbrellas, adjacent to a building with a deck.",
        "public_id": "019fc991-babb-7198-9763-2fc10d5102b7",
        "storage_key": "property/6767906449167622/019fc991-babb-7198-9763-2fc10d5102b7.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Residences Near Quivira Park",
      "seo_description": "Explore Waterford Place, offering residences near Quivira Park in the 66210 area, with serene settings and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "generator",
      "page_item_url": "bluejacket-park-area-apartments-overland-park",
      "search_query": "bluejacket park area apartments in overland park",
      "category": "Park",
      "h1_title": "Apartments Near Bluejacket Park",
      "h2_subtitle": "Experience premier living at Waterford Place, near Bluejacket Park in Overland Park.",
      "page_copy": "Welcome to Waterford Place Apartments & Townhomes, the perfect choice for those seeking a home near Bluejacket Park in Overland Park. Our community offers a harmonious blend of modern amenities and a tranquil setting, ideal for anyone who values convenience and outdoor leisure.\n\nOur selection of one and two-bedroom apartments and townhomes come equipped with features like cozy wood-burning fireplaces and access to beautifully landscaped areas. Situated conveniently near Bluejacket Park, Waterford Place is a top destination for enjoying the green spaces and vibrant community of Overland Park. Come explore your new home today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167622/019fc991-babb-7198-9763-2fc10d5102b7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a kidney-shaped swimming pool with lounge chairs and umbrellas, adjacent to a building with a deck.",
        "public_id": "019fc991-babb-7198-9763-2fc10d5102b7",
        "storage_key": "property/6767906449167622/019fc991-babb-7198-9763-2fc10d5102b7.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Bluejacket Park",
      "seo_description": "Discover Waterford Place, offering top-rated apartments near Bluejacket Park in Overland Park, combining comfort with nature.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167622",
      "source": "generator",
      "page_item_url": "apartments-near-kansas-city-international-airport",
      "search_query": "apartments near kansas city international airport",
      "category": "Transit",
      "h1_title": "Apartments Near Kansas City Airport",
      "h2_subtitle": "Find the perfect home at Waterford Place, conveniently located near Kansas City International Airport.",
      "page_copy": "Discover Waterford Place Apartments & Townhomes, an ideal living destination for those seeking accommodation near Kansas City International Airport. Our community provides the perfect balance of accessibility and peaceful living in a park-like setting.\n\nOur spacious one and two-bedroom apartments and townhomes offer convenient features like cozy fireplaces, while amenities such as a pool add to the appeal. Whether you're catching frequent flights or simply want the convenience of residing near the airport, Waterford Place offers an exceptional choice just a drive away from Kansas City International Airport.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167622/019fc991-babb-7198-9763-2fc10d5102b7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a kidney-shaped swimming pool with lounge chairs and umbrellas, adjacent to a building with a deck.",
        "public_id": "019fc991-babb-7198-9763-2fc10d5102b7",
        "storage_key": "property/6767906449167622/019fc991-babb-7198-9763-2fc10d5102b7.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Kansas City Airport",
      "seo_description": "Check out Waterford Place, offering convenient apartments near Kansas City International Airport for easy access and comfortable living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "12701965257"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-WLXXGVQ7"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Batch 8"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Preferred"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/webchatjs/1ddea256-9174-4c1f-b95a-13b0d3596e0b/app.js?nocache=1&gaTracking=G-KBLSV8KRYM&buttonbgcolor=886b25&buttontextcolor=ffffff&chatheader=0&embed=false\"></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://homes.rently.com/apartments-for-rent/Waterford%20Place/61040"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "913-724-5098"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IllZYy9uSG1DaWprUVVXaWxTdTdva3c9PSIsInZhbHVlIjoiZnN2Vzlrbi9wVXRITlNySFJFUWFYZz09IiwibWFjIjoiZDgyODM0ZjAxYjhlZmY2N2Q0NjlmNDEwZDgzNmFjMmFjOGJiNDYyYjAzY2NhZjQzZjM0ODhkYzAyNTVkODY0YyJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_repli_id": "12701965257",
  "custom_google_gtm_id": "GTM-WLXXGVQ7",
  "custom_rollout_phase": "Batch 8",
  "custom_vibesites_theme": "Preferred",
  "custom_ads_subscription": "essential",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/webchatjs/1ddea256-9174-4c1f-b95a-13b0d3596e0b/app.js?nocache=1&gaTracking=G-KBLSV8KRYM&buttonbgcolor=886b25&buttontextcolor=ffffff&chatheader=0&embed=false\"></script>",
  "custom_seo_subscription": "essential",
  "custom_social_subscription": "none",
  "custom_self_guided_tour_url": "https://homes.rently.com/apartments-for-rent/Waterford%20Place/61040",
  "custom_website_subscription": "turnkey",
  "custom_ppc_tracking_phone_number": "913-724-5098",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IllZYy9uSG1DaWprUVVXaWxTdTdva3c9PSIsInZhbHVlIjoiZnN2Vzlrbi9wVXRITlNySFJFUWFYZz09IiwibWFjIjoiZDgyODM0ZjAxYjhlZmY2N2Q0NjlmNDEwZDgzNmFjMmFjOGJiNDYyYjAzY2NhZjQzZjM0ODhkYzAyNTVkODY0YyJ9",
  "custom_audioeye_site_id": "6ef11d16-17cd-4f77-8df9-87150bad46a1",
  "custom_audioeye_site_hash": "be338a62b5dff88ac9585a334b2fb8a3"
};

export const generatedAt = '2026-11-04T18:28:14.431Z';
